export type Maybe<T> = T | null
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  bigint: any
  interval: any
  numeric: any
  timestamptz: any
}

/** columns and relationships of "auction_house" */
export type AuctionHouse = {
  __typename?: 'AuctionHouse'
  auctionHouseFeeAccount: Scalars['String']
  auctionHouseTreasury: Scalars['String']
  authority: Scalars['String']
  bump: Scalars['Int']
  canChangeSalePrice: Scalars['Boolean']
  createdAt: Scalars['timestamptz']
  creator: Scalars['String']
  feePayerBump: Scalars['Int']
  feeWithdrawalDestination: Scalars['String']
  id: Scalars['String']
  modifiedAt: Scalars['timestamptz']
  requiresSignOff: Scalars['Boolean']
  sellerFeeBasisPoints: Scalars['Int']
  slot: Scalars['bigint']
  treasuryBump: Scalars['Int']
  treasuryMint: Scalars['String']
  treasuryWithdrawalDestination: Scalars['String']
  writeVersion: Scalars['bigint']
}

/** aggregated selection of "auction_house" */
export type AuctionHouseAggregate = {
  __typename?: 'AuctionHouseAggregate'
  aggregate?: Maybe<AuctionHouseAggregateFields>
  nodes: Array<AuctionHouse>
}

/** aggregate fields of "auction_house" */
export type AuctionHouseAggregateFields = {
  __typename?: 'AuctionHouseAggregateFields'
  avg?: Maybe<AuctionHouseAvgFields>
  count: Scalars['Int']
  max?: Maybe<AuctionHouseMaxFields>
  min?: Maybe<AuctionHouseMinFields>
  stddev?: Maybe<AuctionHouseStddevFields>
  stddevPop?: Maybe<AuctionHouseStddev_PopFields>
  stddevSamp?: Maybe<AuctionHouseStddev_SampFields>
  sum?: Maybe<AuctionHouseSumFields>
  varPop?: Maybe<AuctionHouseVar_PopFields>
  varSamp?: Maybe<AuctionHouseVar_SampFields>
  variance?: Maybe<AuctionHouseVarianceFields>
}

/** aggregate fields of "auction_house" */
export type AuctionHouseAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AuctionHouseSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** aggregate avg on columns */
export type AuctionHouseAvgFields = {
  __typename?: 'AuctionHouseAvgFields'
  bump?: Maybe<Scalars['Float']>
  feePayerBump?: Maybe<Scalars['Float']>
  sellerFeeBasisPoints?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  treasuryBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Boolean expression to filter rows from the table "auction_house". All fields are combined with a logical 'AND'. */
export type AuctionHouseBoolExp = {
  _and?: Maybe<Array<AuctionHouseBoolExp>>
  _not?: Maybe<AuctionHouseBoolExp>
  _or?: Maybe<Array<AuctionHouseBoolExp>>
  auctionHouseFeeAccount?: Maybe<StringComparisonExp>
  auctionHouseTreasury?: Maybe<StringComparisonExp>
  authority?: Maybe<StringComparisonExp>
  bump?: Maybe<IntComparisonExp>
  canChangeSalePrice?: Maybe<BooleanComparisonExp>
  createdAt?: Maybe<TimestamptzComparisonExp>
  creator?: Maybe<StringComparisonExp>
  feePayerBump?: Maybe<IntComparisonExp>
  feeWithdrawalDestination?: Maybe<StringComparisonExp>
  id?: Maybe<StringComparisonExp>
  modifiedAt?: Maybe<TimestamptzComparisonExp>
  requiresSignOff?: Maybe<BooleanComparisonExp>
  sellerFeeBasisPoints?: Maybe<IntComparisonExp>
  slot?: Maybe<BigintComparisonExp>
  treasuryBump?: Maybe<IntComparisonExp>
  treasuryMint?: Maybe<StringComparisonExp>
  treasuryWithdrawalDestination?: Maybe<StringComparisonExp>
  writeVersion?: Maybe<BigintComparisonExp>
}

/** aggregate max on columns */
export type AuctionHouseMaxFields = {
  __typename?: 'AuctionHouseMaxFields'
  auctionHouseFeeAccount?: Maybe<Scalars['String']>
  auctionHouseTreasury?: Maybe<Scalars['String']>
  authority?: Maybe<Scalars['String']>
  bump?: Maybe<Scalars['Int']>
  createdAt?: Maybe<Scalars['timestamptz']>
  creator?: Maybe<Scalars['String']>
  feePayerBump?: Maybe<Scalars['Int']>
  feeWithdrawalDestination?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  sellerFeeBasisPoints?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  treasuryBump?: Maybe<Scalars['Int']>
  treasuryMint?: Maybe<Scalars['String']>
  treasuryWithdrawalDestination?: Maybe<Scalars['String']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate min on columns */
export type AuctionHouseMinFields = {
  __typename?: 'AuctionHouseMinFields'
  auctionHouseFeeAccount?: Maybe<Scalars['String']>
  auctionHouseTreasury?: Maybe<Scalars['String']>
  authority?: Maybe<Scalars['String']>
  bump?: Maybe<Scalars['Int']>
  createdAt?: Maybe<Scalars['timestamptz']>
  creator?: Maybe<Scalars['String']>
  feePayerBump?: Maybe<Scalars['Int']>
  feeWithdrawalDestination?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  sellerFeeBasisPoints?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  treasuryBump?: Maybe<Scalars['Int']>
  treasuryMint?: Maybe<Scalars['String']>
  treasuryWithdrawalDestination?: Maybe<Scalars['String']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** Ordering options when selecting data from "auction_house". */
export type AuctionHouseOrderBy = {
  auctionHouseFeeAccount?: Maybe<OrderBy>
  auctionHouseTreasury?: Maybe<OrderBy>
  authority?: Maybe<OrderBy>
  bump?: Maybe<OrderBy>
  canChangeSalePrice?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  creator?: Maybe<OrderBy>
  feePayerBump?: Maybe<OrderBy>
  feeWithdrawalDestination?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  requiresSignOff?: Maybe<OrderBy>
  sellerFeeBasisPoints?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  treasuryBump?: Maybe<OrderBy>
  treasuryMint?: Maybe<OrderBy>
  treasuryWithdrawalDestination?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** select columns of table "auction_house" */
export enum AuctionHouseSelectColumn {
  /** column name */
  AuctionHouseFeeAccount = 'auctionHouseFeeAccount',
  /** column name */
  AuctionHouseTreasury = 'auctionHouseTreasury',
  /** column name */
  Authority = 'authority',
  /** column name */
  Bump = 'bump',
  /** column name */
  CanChangeSalePrice = 'canChangeSalePrice',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Creator = 'creator',
  /** column name */
  FeePayerBump = 'feePayerBump',
  /** column name */
  FeeWithdrawalDestination = 'feeWithdrawalDestination',
  /** column name */
  Id = 'id',
  /** column name */
  ModifiedAt = 'modifiedAt',
  /** column name */
  RequiresSignOff = 'requiresSignOff',
  /** column name */
  SellerFeeBasisPoints = 'sellerFeeBasisPoints',
  /** column name */
  Slot = 'slot',
  /** column name */
  TreasuryBump = 'treasuryBump',
  /** column name */
  TreasuryMint = 'treasuryMint',
  /** column name */
  TreasuryWithdrawalDestination = 'treasuryWithdrawalDestination',
  /** column name */
  WriteVersion = 'writeVersion',
}

/** aggregate stddev on columns */
export type AuctionHouseStddevFields = {
  __typename?: 'AuctionHouseStddevFields'
  bump?: Maybe<Scalars['Float']>
  feePayerBump?: Maybe<Scalars['Float']>
  sellerFeeBasisPoints?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  treasuryBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_pop on columns */
export type AuctionHouseStddev_PopFields = {
  __typename?: 'AuctionHouseStddev_popFields'
  bump?: Maybe<Scalars['Float']>
  feePayerBump?: Maybe<Scalars['Float']>
  sellerFeeBasisPoints?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  treasuryBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_samp on columns */
export type AuctionHouseStddev_SampFields = {
  __typename?: 'AuctionHouseStddev_sampFields'
  bump?: Maybe<Scalars['Float']>
  feePayerBump?: Maybe<Scalars['Float']>
  sellerFeeBasisPoints?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  treasuryBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Streaming cursor of the table "auction_house" */
export type AuctionHouseStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AuctionHouseStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type AuctionHouseStreamCursorValueInput = {
  auctionHouseFeeAccount?: Maybe<Scalars['String']>
  auctionHouseTreasury?: Maybe<Scalars['String']>
  authority?: Maybe<Scalars['String']>
  bump?: Maybe<Scalars['Int']>
  canChangeSalePrice?: Maybe<Scalars['Boolean']>
  createdAt?: Maybe<Scalars['timestamptz']>
  creator?: Maybe<Scalars['String']>
  feePayerBump?: Maybe<Scalars['Int']>
  feeWithdrawalDestination?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  requiresSignOff?: Maybe<Scalars['Boolean']>
  sellerFeeBasisPoints?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  treasuryBump?: Maybe<Scalars['Int']>
  treasuryMint?: Maybe<Scalars['String']>
  treasuryWithdrawalDestination?: Maybe<Scalars['String']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate sum on columns */
export type AuctionHouseSumFields = {
  __typename?: 'AuctionHouseSumFields'
  bump?: Maybe<Scalars['Int']>
  feePayerBump?: Maybe<Scalars['Int']>
  sellerFeeBasisPoints?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  treasuryBump?: Maybe<Scalars['Int']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate var_pop on columns */
export type AuctionHouseVar_PopFields = {
  __typename?: 'AuctionHouseVar_popFields'
  bump?: Maybe<Scalars['Float']>
  feePayerBump?: Maybe<Scalars['Float']>
  sellerFeeBasisPoints?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  treasuryBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate var_samp on columns */
export type AuctionHouseVar_SampFields = {
  __typename?: 'AuctionHouseVar_sampFields'
  bump?: Maybe<Scalars['Float']>
  feePayerBump?: Maybe<Scalars['Float']>
  sellerFeeBasisPoints?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  treasuryBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate variance on columns */
export type AuctionHouseVarianceFields = {
  __typename?: 'AuctionHouseVarianceFields'
  bump?: Maybe<Scalars['Float']>
  feePayerBump?: Maybe<Scalars['Float']>
  sellerFeeBasisPoints?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  treasuryBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** columns and relationships of "bid_receipt" */
export type BidReceipt = {
  __typename?: 'BidReceipt'
  auctionHouse: Scalars['String']
  bookkeeper: Scalars['String']
  bump: Scalars['Int']
  buyer: Scalars['String']
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAt: Scalars['timestamptz']
  createdAtOnChain: Scalars['bigint']
  id: Scalars['String']
  metadata: Scalars['String']
  /** An object relationship */
  metadataObject?: Maybe<Metadata>
  modifiedAt: Scalars['timestamptz']
  price: Scalars['bigint']
  purchaseReceipt?: Maybe<Scalars['String']>
  slot: Scalars['bigint']
  tokenAccount?: Maybe<Scalars['String']>
  tokenSize: Scalars['bigint']
  tradeState: Scalars['String']
  tradeStateBump: Scalars['Int']
  writeVersion: Scalars['bigint']
}

/** aggregated selection of "bid_receipt" */
export type BidReceiptAggregate = {
  __typename?: 'BidReceiptAggregate'
  aggregate?: Maybe<BidReceiptAggregateFields>
  nodes: Array<BidReceipt>
}

/** aggregate fields of "bid_receipt" */
export type BidReceiptAggregateFields = {
  __typename?: 'BidReceiptAggregateFields'
  avg?: Maybe<BidReceiptAvgFields>
  count: Scalars['Int']
  max?: Maybe<BidReceiptMaxFields>
  min?: Maybe<BidReceiptMinFields>
  stddev?: Maybe<BidReceiptStddevFields>
  stddevPop?: Maybe<BidReceiptStddev_PopFields>
  stddevSamp?: Maybe<BidReceiptStddev_SampFields>
  sum?: Maybe<BidReceiptSumFields>
  varPop?: Maybe<BidReceiptVar_PopFields>
  varSamp?: Maybe<BidReceiptVar_SampFields>
  variance?: Maybe<BidReceiptVarianceFields>
}

/** aggregate fields of "bid_receipt" */
export type BidReceiptAggregateFieldsCountArgs = {
  columns?: Maybe<Array<BidReceiptSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** order by aggregate values of table "bid_receipt" */
export type BidReceiptAggregateOrderBy = {
  avg?: Maybe<Bid_Receipt_Avg_Order_By>
  count?: Maybe<OrderBy>
  max?: Maybe<Bid_Receipt_Max_Order_By>
  min?: Maybe<Bid_Receipt_Min_Order_By>
  stddev?: Maybe<Bid_Receipt_Stddev_Order_By>
  stddev_pop?: Maybe<Bid_Receipt_Stddev_Pop_Order_By>
  stddev_samp?: Maybe<Bid_Receipt_Stddev_Samp_Order_By>
  sum?: Maybe<Bid_Receipt_Sum_Order_By>
  var_pop?: Maybe<Bid_Receipt_Var_Pop_Order_By>
  var_samp?: Maybe<Bid_Receipt_Var_Samp_Order_By>
  variance?: Maybe<Bid_Receipt_Variance_Order_By>
}

/** aggregate avg on columns */
export type BidReceiptAvgFields = {
  __typename?: 'BidReceiptAvgFields'
  bump?: Maybe<Scalars['Float']>
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  tradeStateBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Boolean expression to filter rows from the table "bid_receipt". All fields are combined with a logical 'AND'. */
export type BidReceiptBoolExp = {
  _and?: Maybe<Array<BidReceiptBoolExp>>
  _not?: Maybe<BidReceiptBoolExp>
  _or?: Maybe<Array<BidReceiptBoolExp>>
  auctionHouse?: Maybe<StringComparisonExp>
  bookkeeper?: Maybe<StringComparisonExp>
  bump?: Maybe<IntComparisonExp>
  buyer?: Maybe<StringComparisonExp>
  canceledAtOnChain?: Maybe<BigintComparisonExp>
  createdAt?: Maybe<TimestamptzComparisonExp>
  createdAtOnChain?: Maybe<BigintComparisonExp>
  id?: Maybe<StringComparisonExp>
  metadata?: Maybe<StringComparisonExp>
  metadataObject?: Maybe<MetadataBoolExp>
  modifiedAt?: Maybe<TimestamptzComparisonExp>
  price?: Maybe<BigintComparisonExp>
  purchaseReceipt?: Maybe<StringComparisonExp>
  slot?: Maybe<BigintComparisonExp>
  tokenAccount?: Maybe<StringComparisonExp>
  tokenSize?: Maybe<BigintComparisonExp>
  tradeState?: Maybe<StringComparisonExp>
  tradeStateBump?: Maybe<IntComparisonExp>
  writeVersion?: Maybe<BigintComparisonExp>
}

/** aggregate max on columns */
export type BidReceiptMaxFields = {
  __typename?: 'BidReceiptMaxFields'
  auctionHouse?: Maybe<Scalars['String']>
  bookkeeper?: Maybe<Scalars['String']>
  bump?: Maybe<Scalars['Int']>
  buyer?: Maybe<Scalars['String']>
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAt?: Maybe<Scalars['timestamptz']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  purchaseReceipt?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenAccount?: Maybe<Scalars['String']>
  tokenSize?: Maybe<Scalars['bigint']>
  tradeState?: Maybe<Scalars['String']>
  tradeStateBump?: Maybe<Scalars['Int']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate min on columns */
export type BidReceiptMinFields = {
  __typename?: 'BidReceiptMinFields'
  auctionHouse?: Maybe<Scalars['String']>
  bookkeeper?: Maybe<Scalars['String']>
  bump?: Maybe<Scalars['Int']>
  buyer?: Maybe<Scalars['String']>
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAt?: Maybe<Scalars['timestamptz']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  purchaseReceipt?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenAccount?: Maybe<Scalars['String']>
  tokenSize?: Maybe<Scalars['bigint']>
  tradeState?: Maybe<Scalars['String']>
  tradeStateBump?: Maybe<Scalars['Int']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** Ordering options when selecting data from "bid_receipt". */
export type BidReceiptOrderBy = {
  auctionHouse?: Maybe<OrderBy>
  bookkeeper?: Maybe<OrderBy>
  bump?: Maybe<OrderBy>
  buyer?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  metadataObject?: Maybe<MetadataOrderBy>
  modifiedAt?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  purchaseReceipt?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenAccount?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeState?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** select columns of table "bid_receipt" */
export enum BidReceiptSelectColumn {
  /** column name */
  AuctionHouse = 'auctionHouse',
  /** column name */
  Bookkeeper = 'bookkeeper',
  /** column name */
  Bump = 'bump',
  /** column name */
  Buyer = 'buyer',
  /** column name */
  CanceledAtOnChain = 'canceledAtOnChain',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedAtOnChain = 'createdAtOnChain',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ModifiedAt = 'modifiedAt',
  /** column name */
  Price = 'price',
  /** column name */
  PurchaseReceipt = 'purchaseReceipt',
  /** column name */
  Slot = 'slot',
  /** column name */
  TokenAccount = 'tokenAccount',
  /** column name */
  TokenSize = 'tokenSize',
  /** column name */
  TradeState = 'tradeState',
  /** column name */
  TradeStateBump = 'tradeStateBump',
  /** column name */
  WriteVersion = 'writeVersion',
}

/** aggregate stddev on columns */
export type BidReceiptStddevFields = {
  __typename?: 'BidReceiptStddevFields'
  bump?: Maybe<Scalars['Float']>
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  tradeStateBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_pop on columns */
export type BidReceiptStddev_PopFields = {
  __typename?: 'BidReceiptStddev_popFields'
  bump?: Maybe<Scalars['Float']>
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  tradeStateBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_samp on columns */
export type BidReceiptStddev_SampFields = {
  __typename?: 'BidReceiptStddev_sampFields'
  bump?: Maybe<Scalars['Float']>
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  tradeStateBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Streaming cursor of the table "bid_receipt" */
export type BidReceiptStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BidReceiptStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type BidReceiptStreamCursorValueInput = {
  auctionHouse?: Maybe<Scalars['String']>
  bookkeeper?: Maybe<Scalars['String']>
  bump?: Maybe<Scalars['Int']>
  buyer?: Maybe<Scalars['String']>
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAt?: Maybe<Scalars['timestamptz']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  purchaseReceipt?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenAccount?: Maybe<Scalars['String']>
  tokenSize?: Maybe<Scalars['bigint']>
  tradeState?: Maybe<Scalars['String']>
  tradeStateBump?: Maybe<Scalars['Int']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate sum on columns */
export type BidReceiptSumFields = {
  __typename?: 'BidReceiptSumFields'
  bump?: Maybe<Scalars['Int']>
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  price?: Maybe<Scalars['bigint']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
  tradeStateBump?: Maybe<Scalars['Int']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate var_pop on columns */
export type BidReceiptVar_PopFields = {
  __typename?: 'BidReceiptVar_popFields'
  bump?: Maybe<Scalars['Float']>
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  tradeStateBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate var_samp on columns */
export type BidReceiptVar_SampFields = {
  __typename?: 'BidReceiptVar_sampFields'
  bump?: Maybe<Scalars['Float']>
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  tradeStateBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate variance on columns */
export type BidReceiptVarianceFields = {
  __typename?: 'BidReceiptVarianceFields'
  bump?: Maybe<Scalars['Float']>
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  tradeStateBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type BigintComparisonExp = {
  _eq?: Maybe<Scalars['bigint']>
  _gt?: Maybe<Scalars['bigint']>
  _gte?: Maybe<Scalars['bigint']>
  _in?: Maybe<Array<Scalars['bigint']>>
  _isNull?: Maybe<Scalars['Boolean']>
  _lt?: Maybe<Scalars['bigint']>
  _lte?: Maybe<Scalars['bigint']>
  _neq?: Maybe<Scalars['bigint']>
  _nin?: Maybe<Array<Scalars['bigint']>>
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: Maybe<Scalars['Boolean']>
  _gt?: Maybe<Scalars['Boolean']>
  _gte?: Maybe<Scalars['Boolean']>
  _in?: Maybe<Array<Scalars['Boolean']>>
  _isNull?: Maybe<Scalars['Boolean']>
  _lt?: Maybe<Scalars['Boolean']>
  _lte?: Maybe<Scalars['Boolean']>
  _neq?: Maybe<Scalars['Boolean']>
  _nin?: Maybe<Array<Scalars['Boolean']>>
}

/** columns and relationships of "collector_leaderboard" */
export type CollectorLeaderboard = {
  __typename?: 'CollectorLeaderboard'
  allCollected?: Maybe<Scalars['bigint']>
  allEarned?: Maybe<Scalars['numeric']>
  allFlipped?: Maybe<Scalars['bigint']>
  allPercentReturns?: Maybe<Scalars['numeric']>
  allReturns?: Maybe<Scalars['numeric']>
  allSpent?: Maybe<Scalars['numeric']>
  dayCollected?: Maybe<Scalars['bigint']>
  dayEarned?: Maybe<Scalars['numeric']>
  dayFlipped?: Maybe<Scalars['bigint']>
  dayPercentReturns?: Maybe<Scalars['numeric']>
  dayReturns?: Maybe<Scalars['numeric']>
  daySpent?: Maybe<Scalars['numeric']>
  monthCollected?: Maybe<Scalars['bigint']>
  monthEarned?: Maybe<Scalars['numeric']>
  monthFlipped?: Maybe<Scalars['bigint']>
  monthPercentReturns?: Maybe<Scalars['numeric']>
  monthReturns?: Maybe<Scalars['numeric']>
  monthSpent?: Maybe<Scalars['numeric']>
  owner?: Maybe<Scalars['String']>
  weekCollected?: Maybe<Scalars['bigint']>
  weekEarned?: Maybe<Scalars['numeric']>
  weekFlipped?: Maybe<Scalars['bigint']>
  weekPercentReturns?: Maybe<Scalars['numeric']>
  weekReturns?: Maybe<Scalars['numeric']>
  weekSpent?: Maybe<Scalars['numeric']>
}

/** Boolean expression to filter rows from the table "collector_leaderboard". All fields are combined with a logical 'AND'. */
export type CollectorLeaderboardBoolExp = {
  _and?: Maybe<Array<CollectorLeaderboardBoolExp>>
  _not?: Maybe<CollectorLeaderboardBoolExp>
  _or?: Maybe<Array<CollectorLeaderboardBoolExp>>
  allCollected?: Maybe<BigintComparisonExp>
  allEarned?: Maybe<NumericComparisonExp>
  allFlipped?: Maybe<BigintComparisonExp>
  allPercentReturns?: Maybe<NumericComparisonExp>
  allReturns?: Maybe<NumericComparisonExp>
  allSpent?: Maybe<NumericComparisonExp>
  dayCollected?: Maybe<BigintComparisonExp>
  dayEarned?: Maybe<NumericComparisonExp>
  dayFlipped?: Maybe<BigintComparisonExp>
  dayPercentReturns?: Maybe<NumericComparisonExp>
  dayReturns?: Maybe<NumericComparisonExp>
  daySpent?: Maybe<NumericComparisonExp>
  monthCollected?: Maybe<BigintComparisonExp>
  monthEarned?: Maybe<NumericComparisonExp>
  monthFlipped?: Maybe<BigintComparisonExp>
  monthPercentReturns?: Maybe<NumericComparisonExp>
  monthReturns?: Maybe<NumericComparisonExp>
  monthSpent?: Maybe<NumericComparisonExp>
  owner?: Maybe<StringComparisonExp>
  weekCollected?: Maybe<BigintComparisonExp>
  weekEarned?: Maybe<NumericComparisonExp>
  weekFlipped?: Maybe<BigintComparisonExp>
  weekPercentReturns?: Maybe<NumericComparisonExp>
  weekReturns?: Maybe<NumericComparisonExp>
  weekSpent?: Maybe<NumericComparisonExp>
}

/** Ordering options when selecting data from "collector_leaderboard". */
export type CollectorLeaderboardOrderBy = {
  allCollected?: Maybe<OrderBy>
  allEarned?: Maybe<OrderBy>
  allFlipped?: Maybe<OrderBy>
  allPercentReturns?: Maybe<OrderBy>
  allReturns?: Maybe<OrderBy>
  allSpent?: Maybe<OrderBy>
  dayCollected?: Maybe<OrderBy>
  dayEarned?: Maybe<OrderBy>
  dayFlipped?: Maybe<OrderBy>
  dayPercentReturns?: Maybe<OrderBy>
  dayReturns?: Maybe<OrderBy>
  daySpent?: Maybe<OrderBy>
  monthCollected?: Maybe<OrderBy>
  monthEarned?: Maybe<OrderBy>
  monthFlipped?: Maybe<OrderBy>
  monthPercentReturns?: Maybe<OrderBy>
  monthReturns?: Maybe<OrderBy>
  monthSpent?: Maybe<OrderBy>
  owner?: Maybe<OrderBy>
  weekCollected?: Maybe<OrderBy>
  weekEarned?: Maybe<OrderBy>
  weekFlipped?: Maybe<OrderBy>
  weekPercentReturns?: Maybe<OrderBy>
  weekReturns?: Maybe<OrderBy>
  weekSpent?: Maybe<OrderBy>
}

/** select columns of table "collector_leaderboard" */
export enum CollectorLeaderboardSelectColumn {
  /** column name */
  AllCollected = 'allCollected',
  /** column name */
  AllEarned = 'allEarned',
  /** column name */
  AllFlipped = 'allFlipped',
  /** column name */
  AllPercentReturns = 'allPercentReturns',
  /** column name */
  AllReturns = 'allReturns',
  /** column name */
  AllSpent = 'allSpent',
  /** column name */
  DayCollected = 'dayCollected',
  /** column name */
  DayEarned = 'dayEarned',
  /** column name */
  DayFlipped = 'dayFlipped',
  /** column name */
  DayPercentReturns = 'dayPercentReturns',
  /** column name */
  DayReturns = 'dayReturns',
  /** column name */
  DaySpent = 'daySpent',
  /** column name */
  MonthCollected = 'monthCollected',
  /** column name */
  MonthEarned = 'monthEarned',
  /** column name */
  MonthFlipped = 'monthFlipped',
  /** column name */
  MonthPercentReturns = 'monthPercentReturns',
  /** column name */
  MonthReturns = 'monthReturns',
  /** column name */
  MonthSpent = 'monthSpent',
  /** column name */
  Owner = 'owner',
  /** column name */
  WeekCollected = 'weekCollected',
  /** column name */
  WeekEarned = 'weekEarned',
  /** column name */
  WeekFlipped = 'weekFlipped',
  /** column name */
  WeekPercentReturns = 'weekPercentReturns',
  /** column name */
  WeekReturns = 'weekReturns',
  /** column name */
  WeekSpent = 'weekSpent',
}

/** Streaming cursor of the table "collector_leaderboard" */
export type CollectorLeaderboardStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CollectorLeaderboardStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type CollectorLeaderboardStreamCursorValueInput = {
  allCollected?: Maybe<Scalars['bigint']>
  allEarned?: Maybe<Scalars['numeric']>
  allFlipped?: Maybe<Scalars['bigint']>
  allPercentReturns?: Maybe<Scalars['numeric']>
  allReturns?: Maybe<Scalars['numeric']>
  allSpent?: Maybe<Scalars['numeric']>
  dayCollected?: Maybe<Scalars['bigint']>
  dayEarned?: Maybe<Scalars['numeric']>
  dayFlipped?: Maybe<Scalars['bigint']>
  dayPercentReturns?: Maybe<Scalars['numeric']>
  dayReturns?: Maybe<Scalars['numeric']>
  daySpent?: Maybe<Scalars['numeric']>
  monthCollected?: Maybe<Scalars['bigint']>
  monthEarned?: Maybe<Scalars['numeric']>
  monthFlipped?: Maybe<Scalars['bigint']>
  monthPercentReturns?: Maybe<Scalars['numeric']>
  monthReturns?: Maybe<Scalars['numeric']>
  monthSpent?: Maybe<Scalars['numeric']>
  owner?: Maybe<Scalars['String']>
  weekCollected?: Maybe<Scalars['bigint']>
  weekEarned?: Maybe<Scalars['numeric']>
  weekFlipped?: Maybe<Scalars['bigint']>
  weekPercentReturns?: Maybe<Scalars['numeric']>
  weekReturns?: Maybe<Scalars['numeric']>
  weekSpent?: Maybe<Scalars['numeric']>
}

/** columns and relationships of "creator" */
export type Creator = {
  __typename?: 'Creator'
  address: Scalars['String']
  createdAt: Scalars['timestamptz']
  metadata: Scalars['String']
  /** An array relationship */
  metadatas: Array<Metadata>
  /** An aggregate relationship */
  metadatasAggregate: MetadataAggregate
  modifiedAt: Scalars['timestamptz']
  share: Scalars['Int']
  slot: Scalars['bigint']
  verified: Scalars['Boolean']
  writeVersion: Scalars['bigint']
}

/** columns and relationships of "creator" */
export type CreatorMetadatasArgs = {
  distinctOn?: Maybe<Array<MetadataSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MetadataOrderBy>>
  where?: Maybe<MetadataBoolExp>
}

/** columns and relationships of "creator" */
export type CreatorMetadatasAggregateArgs = {
  distinctOn?: Maybe<Array<MetadataSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MetadataOrderBy>>
  where?: Maybe<MetadataBoolExp>
}

/** aggregated selection of "creator" */
export type CreatorAggregate = {
  __typename?: 'CreatorAggregate'
  aggregate?: Maybe<CreatorAggregateFields>
  nodes: Array<Creator>
}

/** aggregate fields of "creator" */
export type CreatorAggregateFields = {
  __typename?: 'CreatorAggregateFields'
  avg?: Maybe<CreatorAvgFields>
  count: Scalars['Int']
  max?: Maybe<CreatorMaxFields>
  min?: Maybe<CreatorMinFields>
  stddev?: Maybe<CreatorStddevFields>
  stddevPop?: Maybe<CreatorStddev_PopFields>
  stddevSamp?: Maybe<CreatorStddev_SampFields>
  sum?: Maybe<CreatorSumFields>
  varPop?: Maybe<CreatorVar_PopFields>
  varSamp?: Maybe<CreatorVar_SampFields>
  variance?: Maybe<CreatorVarianceFields>
}

/** aggregate fields of "creator" */
export type CreatorAggregateFieldsCountArgs = {
  columns?: Maybe<Array<CreatorSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** order by aggregate values of table "creator" */
export type CreatorAggregateOrderBy = {
  avg?: Maybe<Creator_Avg_Order_By>
  count?: Maybe<OrderBy>
  max?: Maybe<Creator_Max_Order_By>
  min?: Maybe<Creator_Min_Order_By>
  stddev?: Maybe<Creator_Stddev_Order_By>
  stddev_pop?: Maybe<Creator_Stddev_Pop_Order_By>
  stddev_samp?: Maybe<Creator_Stddev_Samp_Order_By>
  sum?: Maybe<Creator_Sum_Order_By>
  var_pop?: Maybe<Creator_Var_Pop_Order_By>
  var_samp?: Maybe<Creator_Var_Samp_Order_By>
  variance?: Maybe<Creator_Variance_Order_By>
}

/** aggregate avg on columns */
export type CreatorAvgFields = {
  __typename?: 'CreatorAvgFields'
  share?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Boolean expression to filter rows from the table "creator". All fields are combined with a logical 'AND'. */
export type CreatorBoolExp = {
  _and?: Maybe<Array<CreatorBoolExp>>
  _not?: Maybe<CreatorBoolExp>
  _or?: Maybe<Array<CreatorBoolExp>>
  address?: Maybe<StringComparisonExp>
  createdAt?: Maybe<TimestamptzComparisonExp>
  metadata?: Maybe<StringComparisonExp>
  metadatas?: Maybe<MetadataBoolExp>
  metadatas_aggregate?: Maybe<Metadata_Aggregate_Bool_Exp>
  modifiedAt?: Maybe<TimestamptzComparisonExp>
  share?: Maybe<IntComparisonExp>
  slot?: Maybe<BigintComparisonExp>
  verified?: Maybe<BooleanComparisonExp>
  writeVersion?: Maybe<BigintComparisonExp>
}

/** columns and relationships of "creator_leaderboard" */
export type CreatorLeaderboard = {
  __typename?: 'CreatorLeaderboard'
  allCollectors?: Maybe<Scalars['bigint']>
  allPrimarySales?: Maybe<Scalars['bigint']>
  allPrimarySalesSol?: Maybe<Scalars['numeric']>
  allSales?: Maybe<Scalars['bigint']>
  allSalesSol?: Maybe<Scalars['numeric']>
  allSecondarySales?: Maybe<Scalars['bigint']>
  allSecondarySalesSol?: Maybe<Scalars['numeric']>
  dayCollectors?: Maybe<Scalars['bigint']>
  dayPrimarySales?: Maybe<Scalars['bigint']>
  dayPrimarySalesSol?: Maybe<Scalars['numeric']>
  daySales?: Maybe<Scalars['bigint']>
  daySalesSol?: Maybe<Scalars['numeric']>
  daySecondarySales?: Maybe<Scalars['bigint']>
  daySecondarySalesSol?: Maybe<Scalars['numeric']>
  monthCollectors?: Maybe<Scalars['bigint']>
  monthPrimarySales?: Maybe<Scalars['bigint']>
  monthPrimarySalesSol?: Maybe<Scalars['numeric']>
  monthSales?: Maybe<Scalars['bigint']>
  monthSalesSol?: Maybe<Scalars['numeric']>
  monthSecondarySales?: Maybe<Scalars['bigint']>
  monthSecondarySalesSol?: Maybe<Scalars['numeric']>
  tokenOwner?: Maybe<Scalars['String']>
  weekCollectors?: Maybe<Scalars['bigint']>
  weekPrimarySales?: Maybe<Scalars['bigint']>
  weekPrimarySalesSol?: Maybe<Scalars['numeric']>
  weekSales?: Maybe<Scalars['bigint']>
  weekSalesSol?: Maybe<Scalars['numeric']>
  weekSecondarySales?: Maybe<Scalars['bigint']>
  weekSecondarySalesSol?: Maybe<Scalars['numeric']>
}

/** Boolean expression to filter rows from the table "creator_leaderboard". All fields are combined with a logical 'AND'. */
export type CreatorLeaderboardBoolExp = {
  _and?: Maybe<Array<CreatorLeaderboardBoolExp>>
  _not?: Maybe<CreatorLeaderboardBoolExp>
  _or?: Maybe<Array<CreatorLeaderboardBoolExp>>
  allCollectors?: Maybe<BigintComparisonExp>
  allPrimarySales?: Maybe<BigintComparisonExp>
  allPrimarySalesSol?: Maybe<NumericComparisonExp>
  allSales?: Maybe<BigintComparisonExp>
  allSalesSol?: Maybe<NumericComparisonExp>
  allSecondarySales?: Maybe<BigintComparisonExp>
  allSecondarySalesSol?: Maybe<NumericComparisonExp>
  dayCollectors?: Maybe<BigintComparisonExp>
  dayPrimarySales?: Maybe<BigintComparisonExp>
  dayPrimarySalesSol?: Maybe<NumericComparisonExp>
  daySales?: Maybe<BigintComparisonExp>
  daySalesSol?: Maybe<NumericComparisonExp>
  daySecondarySales?: Maybe<BigintComparisonExp>
  daySecondarySalesSol?: Maybe<NumericComparisonExp>
  monthCollectors?: Maybe<BigintComparisonExp>
  monthPrimarySales?: Maybe<BigintComparisonExp>
  monthPrimarySalesSol?: Maybe<NumericComparisonExp>
  monthSales?: Maybe<BigintComparisonExp>
  monthSalesSol?: Maybe<NumericComparisonExp>
  monthSecondarySales?: Maybe<BigintComparisonExp>
  monthSecondarySalesSol?: Maybe<NumericComparisonExp>
  tokenOwner?: Maybe<StringComparisonExp>
  weekCollectors?: Maybe<BigintComparisonExp>
  weekPrimarySales?: Maybe<BigintComparisonExp>
  weekPrimarySalesSol?: Maybe<NumericComparisonExp>
  weekSales?: Maybe<BigintComparisonExp>
  weekSalesSol?: Maybe<NumericComparisonExp>
  weekSecondarySales?: Maybe<BigintComparisonExp>
  weekSecondarySalesSol?: Maybe<NumericComparisonExp>
}

/** Ordering options when selecting data from "creator_leaderboard". */
export type CreatorLeaderboardOrderBy = {
  allCollectors?: Maybe<OrderBy>
  allPrimarySales?: Maybe<OrderBy>
  allPrimarySalesSol?: Maybe<OrderBy>
  allSales?: Maybe<OrderBy>
  allSalesSol?: Maybe<OrderBy>
  allSecondarySales?: Maybe<OrderBy>
  allSecondarySalesSol?: Maybe<OrderBy>
  dayCollectors?: Maybe<OrderBy>
  dayPrimarySales?: Maybe<OrderBy>
  dayPrimarySalesSol?: Maybe<OrderBy>
  daySales?: Maybe<OrderBy>
  daySalesSol?: Maybe<OrderBy>
  daySecondarySales?: Maybe<OrderBy>
  daySecondarySalesSol?: Maybe<OrderBy>
  monthCollectors?: Maybe<OrderBy>
  monthPrimarySales?: Maybe<OrderBy>
  monthPrimarySalesSol?: Maybe<OrderBy>
  monthSales?: Maybe<OrderBy>
  monthSalesSol?: Maybe<OrderBy>
  monthSecondarySales?: Maybe<OrderBy>
  monthSecondarySalesSol?: Maybe<OrderBy>
  tokenOwner?: Maybe<OrderBy>
  weekCollectors?: Maybe<OrderBy>
  weekPrimarySales?: Maybe<OrderBy>
  weekPrimarySalesSol?: Maybe<OrderBy>
  weekSales?: Maybe<OrderBy>
  weekSalesSol?: Maybe<OrderBy>
  weekSecondarySales?: Maybe<OrderBy>
  weekSecondarySalesSol?: Maybe<OrderBy>
}

/** select columns of table "creator_leaderboard" */
export enum CreatorLeaderboardSelectColumn {
  /** column name */
  AllCollectors = 'allCollectors',
  /** column name */
  AllPrimarySales = 'allPrimarySales',
  /** column name */
  AllPrimarySalesSol = 'allPrimarySalesSol',
  /** column name */
  AllSales = 'allSales',
  /** column name */
  AllSalesSol = 'allSalesSol',
  /** column name */
  AllSecondarySales = 'allSecondarySales',
  /** column name */
  AllSecondarySalesSol = 'allSecondarySalesSol',
  /** column name */
  DayCollectors = 'dayCollectors',
  /** column name */
  DayPrimarySales = 'dayPrimarySales',
  /** column name */
  DayPrimarySalesSol = 'dayPrimarySalesSol',
  /** column name */
  DaySales = 'daySales',
  /** column name */
  DaySalesSol = 'daySalesSol',
  /** column name */
  DaySecondarySales = 'daySecondarySales',
  /** column name */
  DaySecondarySalesSol = 'daySecondarySalesSol',
  /** column name */
  MonthCollectors = 'monthCollectors',
  /** column name */
  MonthPrimarySales = 'monthPrimarySales',
  /** column name */
  MonthPrimarySalesSol = 'monthPrimarySalesSol',
  /** column name */
  MonthSales = 'monthSales',
  /** column name */
  MonthSalesSol = 'monthSalesSol',
  /** column name */
  MonthSecondarySales = 'monthSecondarySales',
  /** column name */
  MonthSecondarySalesSol = 'monthSecondarySalesSol',
  /** column name */
  TokenOwner = 'tokenOwner',
  /** column name */
  WeekCollectors = 'weekCollectors',
  /** column name */
  WeekPrimarySales = 'weekPrimarySales',
  /** column name */
  WeekPrimarySalesSol = 'weekPrimarySalesSol',
  /** column name */
  WeekSales = 'weekSales',
  /** column name */
  WeekSalesSol = 'weekSalesSol',
  /** column name */
  WeekSecondarySales = 'weekSecondarySales',
  /** column name */
  WeekSecondarySalesSol = 'weekSecondarySalesSol',
}

/** Streaming cursor of the table "creator_leaderboard" */
export type CreatorLeaderboardStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CreatorLeaderboardStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type CreatorLeaderboardStreamCursorValueInput = {
  allCollectors?: Maybe<Scalars['bigint']>
  allPrimarySales?: Maybe<Scalars['bigint']>
  allPrimarySalesSol?: Maybe<Scalars['numeric']>
  allSales?: Maybe<Scalars['bigint']>
  allSalesSol?: Maybe<Scalars['numeric']>
  allSecondarySales?: Maybe<Scalars['bigint']>
  allSecondarySalesSol?: Maybe<Scalars['numeric']>
  dayCollectors?: Maybe<Scalars['bigint']>
  dayPrimarySales?: Maybe<Scalars['bigint']>
  dayPrimarySalesSol?: Maybe<Scalars['numeric']>
  daySales?: Maybe<Scalars['bigint']>
  daySalesSol?: Maybe<Scalars['numeric']>
  daySecondarySales?: Maybe<Scalars['bigint']>
  daySecondarySalesSol?: Maybe<Scalars['numeric']>
  monthCollectors?: Maybe<Scalars['bigint']>
  monthPrimarySales?: Maybe<Scalars['bigint']>
  monthPrimarySalesSol?: Maybe<Scalars['numeric']>
  monthSales?: Maybe<Scalars['bigint']>
  monthSalesSol?: Maybe<Scalars['numeric']>
  monthSecondarySales?: Maybe<Scalars['bigint']>
  monthSecondarySalesSol?: Maybe<Scalars['numeric']>
  tokenOwner?: Maybe<Scalars['String']>
  weekCollectors?: Maybe<Scalars['bigint']>
  weekPrimarySales?: Maybe<Scalars['bigint']>
  weekPrimarySalesSol?: Maybe<Scalars['numeric']>
  weekSales?: Maybe<Scalars['bigint']>
  weekSalesSol?: Maybe<Scalars['numeric']>
  weekSecondarySales?: Maybe<Scalars['bigint']>
  weekSecondarySalesSol?: Maybe<Scalars['numeric']>
}

/** aggregate max on columns */
export type CreatorMaxFields = {
  __typename?: 'CreatorMaxFields'
  address?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  metadata?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  share?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate min on columns */
export type CreatorMinFields = {
  __typename?: 'CreatorMinFields'
  address?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  metadata?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  share?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** Ordering options when selecting data from "creator". */
export type CreatorOrderBy = {
  address?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  metadatasAggregate?: Maybe<MetadataAggregateOrderBy>
  modifiedAt?: Maybe<OrderBy>
  share?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  verified?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** select columns of table "creator" */
export enum CreatorSelectColumn {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ModifiedAt = 'modifiedAt',
  /** column name */
  Share = 'share',
  /** column name */
  Slot = 'slot',
  /** column name */
  Verified = 'verified',
  /** column name */
  WriteVersion = 'writeVersion',
}

/** aggregate stddev on columns */
export type CreatorStddevFields = {
  __typename?: 'CreatorStddevFields'
  share?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_pop on columns */
export type CreatorStddev_PopFields = {
  __typename?: 'CreatorStddev_popFields'
  share?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_samp on columns */
export type CreatorStddev_SampFields = {
  __typename?: 'CreatorStddev_sampFields'
  share?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Streaming cursor of the table "creator" */
export type CreatorStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CreatorStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type CreatorStreamCursorValueInput = {
  address?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  metadata?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  share?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  verified?: Maybe<Scalars['Boolean']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate sum on columns */
export type CreatorSumFields = {
  __typename?: 'CreatorSumFields'
  share?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate var_pop on columns */
export type CreatorVar_PopFields = {
  __typename?: 'CreatorVar_popFields'
  share?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate var_samp on columns */
export type CreatorVar_SampFields = {
  __typename?: 'CreatorVar_sampFields'
  share?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate variance on columns */
export type CreatorVarianceFields = {
  __typename?: 'CreatorVarianceFields'
  share?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** ordering argument of a cursor */
export enum CursorOrdering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC',
}

/** columns and relationships of "distances" */
export type Distances = {
  __typename?: 'Distances'
  distance?: Maybe<Scalars['interval']>
  mint?: Maybe<Scalars['String']>
  /** An object relationship */
  mintObject?: Maybe<Mint>
}

/** Boolean expression to filter rows from the table "distances". All fields are combined with a logical 'AND'. */
export type DistancesBoolExp = {
  _and?: Maybe<Array<DistancesBoolExp>>
  _not?: Maybe<DistancesBoolExp>
  _or?: Maybe<Array<DistancesBoolExp>>
  distance?: Maybe<IntervalComparisonExp>
  mint?: Maybe<StringComparisonExp>
  mintObject?: Maybe<MintBoolExp>
}

/** Ordering options when selecting data from "distances". */
export type DistancesOrderBy = {
  distance?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  mintObject?: Maybe<MintOrderBy>
}

/** select columns of table "distances" */
export enum DistancesSelectColumn {
  /** column name */
  Distance = 'distance',
  /** column name */
  Mint = 'mint',
}

/** Streaming cursor of the table "distances" */
export type DistancesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DistancesStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type DistancesStreamCursorValueInput = {
  distance?: Maybe<Scalars['interval']>
  mint?: Maybe<Scalars['String']>
}

/** columns and relationships of "drop_times" */
export type DropTimes = {
  __typename?: 'DropTimes'
  dropTime?: Maybe<Scalars['timestamptz']>
  mint: Scalars['String']
  /** An object relationship */
  mintObject?: Maybe<Mint>
}

/** aggregated selection of "drop_times" */
export type DropTimesAggregate = {
  __typename?: 'DropTimesAggregate'
  aggregate?: Maybe<DropTimesAggregateFields>
  nodes: Array<DropTimes>
}

/** aggregate fields of "drop_times" */
export type DropTimesAggregateFields = {
  __typename?: 'DropTimesAggregateFields'
  count: Scalars['Int']
  max?: Maybe<DropTimesMaxFields>
  min?: Maybe<DropTimesMinFields>
}

/** aggregate fields of "drop_times" */
export type DropTimesAggregateFieldsCountArgs = {
  columns?: Maybe<Array<DropTimesSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** Boolean expression to filter rows from the table "drop_times". All fields are combined with a logical 'AND'. */
export type DropTimesBoolExp = {
  _and?: Maybe<Array<DropTimesBoolExp>>
  _not?: Maybe<DropTimesBoolExp>
  _or?: Maybe<Array<DropTimesBoolExp>>
  dropTime?: Maybe<TimestamptzComparisonExp>
  mint?: Maybe<StringComparisonExp>
  mintObject?: Maybe<MintBoolExp>
}

/** aggregate max on columns */
export type DropTimesMaxFields = {
  __typename?: 'DropTimesMaxFields'
  dropTime?: Maybe<Scalars['timestamptz']>
  mint?: Maybe<Scalars['String']>
}

/** aggregate min on columns */
export type DropTimesMinFields = {
  __typename?: 'DropTimesMinFields'
  dropTime?: Maybe<Scalars['timestamptz']>
  mint?: Maybe<Scalars['String']>
}

/** Ordering options when selecting data from "drop_times". */
export type DropTimesOrderBy = {
  dropTime?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  mintObject?: Maybe<MintOrderBy>
}

/** select columns of table "drop_times" */
export enum DropTimesSelectColumn {
  /** column name */
  DropTime = 'dropTime',
  /** column name */
  Mint = 'mint',
}

/** Streaming cursor of the table "drop_times" */
export type DropTimesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DropTimesStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type DropTimesStreamCursorValueInput = {
  dropTime?: Maybe<Scalars['timestamptz']>
  mint?: Maybe<Scalars['String']>
}

/** columns and relationships of "edition_metadata" */
export type EditionMetadata = {
  __typename?: 'EditionMetadata'
  createdAt: Scalars['timestamptz']
  creatorFeeBasisPoints: Scalars['Int']
  id: Scalars['String']
  maxSupply: Scalars['Int']
  metadata: Scalars['String']
  /** An object relationship */
  metadataObject?: Maybe<Metadata>
  mint: Scalars['String']
  /** An object relationship */
  mintObject?: Maybe<Mint>
  modifiedAt: Scalars['timestamptz']
  platformFeeBasisPoints: Scalars['Int']
  primarySalePrice: Scalars['bigint']
  primarySaleTokenLimit: Scalars['Int']
  slot: Scalars['bigint']
  tokenOwner: Scalars['String']
  writeVersion: Scalars['bigint']
}

/** aggregated selection of "edition_metadata" */
export type EditionMetadataAggregate = {
  __typename?: 'EditionMetadataAggregate'
  aggregate?: Maybe<EditionMetadataAggregateFields>
  nodes: Array<EditionMetadata>
}

/** aggregate fields of "edition_metadata" */
export type EditionMetadataAggregateFields = {
  __typename?: 'EditionMetadataAggregateFields'
  avg?: Maybe<EditionMetadataAvgFields>
  count: Scalars['Int']
  max?: Maybe<EditionMetadataMaxFields>
  min?: Maybe<EditionMetadataMinFields>
  stddev?: Maybe<EditionMetadataStddevFields>
  stddevPop?: Maybe<EditionMetadataStddev_PopFields>
  stddevSamp?: Maybe<EditionMetadataStddev_SampFields>
  sum?: Maybe<EditionMetadataSumFields>
  varPop?: Maybe<EditionMetadataVar_PopFields>
  varSamp?: Maybe<EditionMetadataVar_SampFields>
  variance?: Maybe<EditionMetadataVarianceFields>
}

/** aggregate fields of "edition_metadata" */
export type EditionMetadataAggregateFieldsCountArgs = {
  columns?: Maybe<Array<EditionMetadataSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** aggregate avg on columns */
export type EditionMetadataAvgFields = {
  __typename?: 'EditionMetadataAvgFields'
  creatorFeeBasisPoints?: Maybe<Scalars['Float']>
  maxSupply?: Maybe<Scalars['Float']>
  platformFeeBasisPoints?: Maybe<Scalars['Float']>
  primarySalePrice?: Maybe<Scalars['Float']>
  primarySaleTokenLimit?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Boolean expression to filter rows from the table "edition_metadata". All fields are combined with a logical 'AND'. */
export type EditionMetadataBoolExp = {
  _and?: Maybe<Array<EditionMetadataBoolExp>>
  _not?: Maybe<EditionMetadataBoolExp>
  _or?: Maybe<Array<EditionMetadataBoolExp>>
  createdAt?: Maybe<TimestamptzComparisonExp>
  creatorFeeBasisPoints?: Maybe<IntComparisonExp>
  id?: Maybe<StringComparisonExp>
  maxSupply?: Maybe<IntComparisonExp>
  metadata?: Maybe<StringComparisonExp>
  metadataObject?: Maybe<MetadataBoolExp>
  mint?: Maybe<StringComparisonExp>
  mintObject?: Maybe<MintBoolExp>
  modifiedAt?: Maybe<TimestamptzComparisonExp>
  platformFeeBasisPoints?: Maybe<IntComparisonExp>
  primarySalePrice?: Maybe<BigintComparisonExp>
  primarySaleTokenLimit?: Maybe<IntComparisonExp>
  slot?: Maybe<BigintComparisonExp>
  tokenOwner?: Maybe<StringComparisonExp>
  writeVersion?: Maybe<BigintComparisonExp>
}

/** aggregate max on columns */
export type EditionMetadataMaxFields = {
  __typename?: 'EditionMetadataMaxFields'
  createdAt?: Maybe<Scalars['timestamptz']>
  creatorFeeBasisPoints?: Maybe<Scalars['Int']>
  id?: Maybe<Scalars['String']>
  maxSupply?: Maybe<Scalars['Int']>
  metadata?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  platformFeeBasisPoints?: Maybe<Scalars['Int']>
  primarySalePrice?: Maybe<Scalars['bigint']>
  primarySaleTokenLimit?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  tokenOwner?: Maybe<Scalars['String']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate min on columns */
export type EditionMetadataMinFields = {
  __typename?: 'EditionMetadataMinFields'
  createdAt?: Maybe<Scalars['timestamptz']>
  creatorFeeBasisPoints?: Maybe<Scalars['Int']>
  id?: Maybe<Scalars['String']>
  maxSupply?: Maybe<Scalars['Int']>
  metadata?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  platformFeeBasisPoints?: Maybe<Scalars['Int']>
  primarySalePrice?: Maybe<Scalars['bigint']>
  primarySaleTokenLimit?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  tokenOwner?: Maybe<Scalars['String']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** Ordering options when selecting data from "edition_metadata". */
export type EditionMetadataOrderBy = {
  createdAt?: Maybe<OrderBy>
  creatorFeeBasisPoints?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  maxSupply?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  metadataObject?: Maybe<MetadataOrderBy>
  mint?: Maybe<OrderBy>
  mintObject?: Maybe<MintOrderBy>
  modifiedAt?: Maybe<OrderBy>
  platformFeeBasisPoints?: Maybe<OrderBy>
  primarySalePrice?: Maybe<OrderBy>
  primarySaleTokenLimit?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenOwner?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** select columns of table "edition_metadata" */
export enum EditionMetadataSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatorFeeBasisPoints = 'creatorFeeBasisPoints',
  /** column name */
  Id = 'id',
  /** column name */
  MaxSupply = 'maxSupply',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Mint = 'mint',
  /** column name */
  ModifiedAt = 'modifiedAt',
  /** column name */
  PlatformFeeBasisPoints = 'platformFeeBasisPoints',
  /** column name */
  PrimarySalePrice = 'primarySalePrice',
  /** column name */
  PrimarySaleTokenLimit = 'primarySaleTokenLimit',
  /** column name */
  Slot = 'slot',
  /** column name */
  TokenOwner = 'tokenOwner',
  /** column name */
  WriteVersion = 'writeVersion',
}

/** aggregate stddev on columns */
export type EditionMetadataStddevFields = {
  __typename?: 'EditionMetadataStddevFields'
  creatorFeeBasisPoints?: Maybe<Scalars['Float']>
  maxSupply?: Maybe<Scalars['Float']>
  platformFeeBasisPoints?: Maybe<Scalars['Float']>
  primarySalePrice?: Maybe<Scalars['Float']>
  primarySaleTokenLimit?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_pop on columns */
export type EditionMetadataStddev_PopFields = {
  __typename?: 'EditionMetadataStddev_popFields'
  creatorFeeBasisPoints?: Maybe<Scalars['Float']>
  maxSupply?: Maybe<Scalars['Float']>
  platformFeeBasisPoints?: Maybe<Scalars['Float']>
  primarySalePrice?: Maybe<Scalars['Float']>
  primarySaleTokenLimit?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_samp on columns */
export type EditionMetadataStddev_SampFields = {
  __typename?: 'EditionMetadataStddev_sampFields'
  creatorFeeBasisPoints?: Maybe<Scalars['Float']>
  maxSupply?: Maybe<Scalars['Float']>
  platformFeeBasisPoints?: Maybe<Scalars['Float']>
  primarySalePrice?: Maybe<Scalars['Float']>
  primarySaleTokenLimit?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Streaming cursor of the table "edition_metadata" */
export type EditionMetadataStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EditionMetadataStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type EditionMetadataStreamCursorValueInput = {
  createdAt?: Maybe<Scalars['timestamptz']>
  creatorFeeBasisPoints?: Maybe<Scalars['Int']>
  id?: Maybe<Scalars['String']>
  maxSupply?: Maybe<Scalars['Int']>
  metadata?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  platformFeeBasisPoints?: Maybe<Scalars['Int']>
  primarySalePrice?: Maybe<Scalars['bigint']>
  primarySaleTokenLimit?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  tokenOwner?: Maybe<Scalars['String']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate sum on columns */
export type EditionMetadataSumFields = {
  __typename?: 'EditionMetadataSumFields'
  creatorFeeBasisPoints?: Maybe<Scalars['Int']>
  maxSupply?: Maybe<Scalars['Int']>
  platformFeeBasisPoints?: Maybe<Scalars['Int']>
  primarySalePrice?: Maybe<Scalars['bigint']>
  primarySaleTokenLimit?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate var_pop on columns */
export type EditionMetadataVar_PopFields = {
  __typename?: 'EditionMetadataVar_popFields'
  creatorFeeBasisPoints?: Maybe<Scalars['Float']>
  maxSupply?: Maybe<Scalars['Float']>
  platformFeeBasisPoints?: Maybe<Scalars['Float']>
  primarySalePrice?: Maybe<Scalars['Float']>
  primarySaleTokenLimit?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate var_samp on columns */
export type EditionMetadataVar_SampFields = {
  __typename?: 'EditionMetadataVar_sampFields'
  creatorFeeBasisPoints?: Maybe<Scalars['Float']>
  maxSupply?: Maybe<Scalars['Float']>
  platformFeeBasisPoints?: Maybe<Scalars['Float']>
  primarySalePrice?: Maybe<Scalars['Float']>
  primarySaleTokenLimit?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate variance on columns */
export type EditionMetadataVarianceFields = {
  __typename?: 'EditionMetadataVarianceFields'
  creatorFeeBasisPoints?: Maybe<Scalars['Float']>
  maxSupply?: Maybe<Scalars['Float']>
  platformFeeBasisPoints?: Maybe<Scalars['Float']>
  primarySalePrice?: Maybe<Scalars['Float']>
  primarySaleTokenLimit?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** columns and relationships of "floor_price" */
export type FloorPrice = {
  __typename?: 'FloorPrice'
  floor?: Maybe<Scalars['bigint']>
  mint?: Maybe<Scalars['String']>
  /** An object relationship */
  mintObject?: Maybe<Mint>
}

/** aggregated selection of "floor_price" */
export type FloorPriceAggregate = {
  __typename?: 'FloorPriceAggregate'
  aggregate?: Maybe<FloorPriceAggregateFields>
  nodes: Array<FloorPrice>
}

/** aggregate fields of "floor_price" */
export type FloorPriceAggregateFields = {
  __typename?: 'FloorPriceAggregateFields'
  avg?: Maybe<FloorPriceAvgFields>
  count: Scalars['Int']
  max?: Maybe<FloorPriceMaxFields>
  min?: Maybe<FloorPriceMinFields>
  stddev?: Maybe<FloorPriceStddevFields>
  stddevPop?: Maybe<FloorPriceStddev_PopFields>
  stddevSamp?: Maybe<FloorPriceStddev_SampFields>
  sum?: Maybe<FloorPriceSumFields>
  varPop?: Maybe<FloorPriceVar_PopFields>
  varSamp?: Maybe<FloorPriceVar_SampFields>
  variance?: Maybe<FloorPriceVarianceFields>
}

/** aggregate fields of "floor_price" */
export type FloorPriceAggregateFieldsCountArgs = {
  columns?: Maybe<Array<FloorPriceSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** aggregate avg on columns */
export type FloorPriceAvgFields = {
  __typename?: 'FloorPriceAvgFields'
  floor?: Maybe<Scalars['Float']>
}

/** Boolean expression to filter rows from the table "floor_price". All fields are combined with a logical 'AND'. */
export type FloorPriceBoolExp = {
  _and?: Maybe<Array<FloorPriceBoolExp>>
  _not?: Maybe<FloorPriceBoolExp>
  _or?: Maybe<Array<FloorPriceBoolExp>>
  floor?: Maybe<BigintComparisonExp>
  mint?: Maybe<StringComparisonExp>
  mintObject?: Maybe<MintBoolExp>
}

/** aggregate max on columns */
export type FloorPriceMaxFields = {
  __typename?: 'FloorPriceMaxFields'
  floor?: Maybe<Scalars['bigint']>
  mint?: Maybe<Scalars['String']>
}

/** aggregate min on columns */
export type FloorPriceMinFields = {
  __typename?: 'FloorPriceMinFields'
  floor?: Maybe<Scalars['bigint']>
  mint?: Maybe<Scalars['String']>
}

/** Ordering options when selecting data from "floor_price". */
export type FloorPriceOrderBy = {
  floor?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  mintObject?: Maybe<MintOrderBy>
}

/** select columns of table "floor_price" */
export enum FloorPriceSelectColumn {
  /** column name */
  Floor = 'floor',
  /** column name */
  Mint = 'mint',
}

/** aggregate stddev on columns */
export type FloorPriceStddevFields = {
  __typename?: 'FloorPriceStddevFields'
  floor?: Maybe<Scalars['Float']>
}

/** aggregate stddev_pop on columns */
export type FloorPriceStddev_PopFields = {
  __typename?: 'FloorPriceStddev_popFields'
  floor?: Maybe<Scalars['Float']>
}

/** aggregate stddev_samp on columns */
export type FloorPriceStddev_SampFields = {
  __typename?: 'FloorPriceStddev_sampFields'
  floor?: Maybe<Scalars['Float']>
}

/** Streaming cursor of the table "floor_price" */
export type FloorPriceStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FloorPriceStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type FloorPriceStreamCursorValueInput = {
  floor?: Maybe<Scalars['bigint']>
  mint?: Maybe<Scalars['String']>
}

/** aggregate sum on columns */
export type FloorPriceSumFields = {
  __typename?: 'FloorPriceSumFields'
  floor?: Maybe<Scalars['bigint']>
}

/** aggregate var_pop on columns */
export type FloorPriceVar_PopFields = {
  __typename?: 'FloorPriceVar_popFields'
  floor?: Maybe<Scalars['Float']>
}

/** aggregate var_samp on columns */
export type FloorPriceVar_SampFields = {
  __typename?: 'FloorPriceVar_sampFields'
  floor?: Maybe<Scalars['Float']>
}

/** aggregate variance on columns */
export type FloorPriceVarianceFields = {
  __typename?: 'FloorPriceVarianceFields'
  floor?: Maybe<Scalars['Float']>
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: Maybe<Scalars['Int']>
  _gt?: Maybe<Scalars['Int']>
  _gte?: Maybe<Scalars['Int']>
  _in?: Maybe<Array<Scalars['Int']>>
  _isNull?: Maybe<Scalars['Boolean']>
  _lt?: Maybe<Scalars['Int']>
  _lte?: Maybe<Scalars['Int']>
  _neq?: Maybe<Scalars['Int']>
  _nin?: Maybe<Array<Scalars['Int']>>
}

/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type IntervalComparisonExp = {
  _eq?: Maybe<Scalars['interval']>
  _gt?: Maybe<Scalars['interval']>
  _gte?: Maybe<Scalars['interval']>
  _in?: Maybe<Array<Scalars['interval']>>
  _isNull?: Maybe<Scalars['Boolean']>
  _lt?: Maybe<Scalars['interval']>
  _lte?: Maybe<Scalars['interval']>
  _neq?: Maybe<Scalars['interval']>
  _nin?: Maybe<Array<Scalars['interval']>>
}

/** columns and relationships of "listing_receipt" */
export type ListingReceipt = {
  __typename?: 'ListingReceipt'
  auctionHouse: Scalars['String']
  bookkeeper: Scalars['String']
  bump: Scalars['Int']
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAt: Scalars['timestamptz']
  createdAtOnChain: Scalars['bigint']
  id: Scalars['String']
  metadata: Scalars['String']
  /** An object relationship */
  metadataObject?: Maybe<Metadata>
  modifiedAt: Scalars['timestamptz']
  price: Scalars['bigint']
  purchaseReceipt?: Maybe<Scalars['String']>
  seller: Scalars['String']
  slot: Scalars['bigint']
  tokenSize: Scalars['bigint']
  tradeState: Scalars['String']
  tradeStateBump: Scalars['Int']
  writeVersion: Scalars['bigint']
}

/** aggregated selection of "listing_receipt" */
export type ListingReceiptAggregate = {
  __typename?: 'ListingReceiptAggregate'
  aggregate?: Maybe<ListingReceiptAggregateFields>
  nodes: Array<ListingReceipt>
}

/** aggregate fields of "listing_receipt" */
export type ListingReceiptAggregateFields = {
  __typename?: 'ListingReceiptAggregateFields'
  avg?: Maybe<ListingReceiptAvgFields>
  count: Scalars['Int']
  max?: Maybe<ListingReceiptMaxFields>
  min?: Maybe<ListingReceiptMinFields>
  stddev?: Maybe<ListingReceiptStddevFields>
  stddevPop?: Maybe<ListingReceiptStddev_PopFields>
  stddevSamp?: Maybe<ListingReceiptStddev_SampFields>
  sum?: Maybe<ListingReceiptSumFields>
  varPop?: Maybe<ListingReceiptVar_PopFields>
  varSamp?: Maybe<ListingReceiptVar_SampFields>
  variance?: Maybe<ListingReceiptVarianceFields>
}

/** aggregate fields of "listing_receipt" */
export type ListingReceiptAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ListingReceiptSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** order by aggregate values of table "listing_receipt" */
export type ListingReceiptAggregateOrderBy = {
  avg?: Maybe<Listing_Receipt_Avg_Order_By>
  count?: Maybe<OrderBy>
  max?: Maybe<Listing_Receipt_Max_Order_By>
  min?: Maybe<Listing_Receipt_Min_Order_By>
  stddev?: Maybe<Listing_Receipt_Stddev_Order_By>
  stddev_pop?: Maybe<Listing_Receipt_Stddev_Pop_Order_By>
  stddev_samp?: Maybe<Listing_Receipt_Stddev_Samp_Order_By>
  sum?: Maybe<Listing_Receipt_Sum_Order_By>
  var_pop?: Maybe<Listing_Receipt_Var_Pop_Order_By>
  var_samp?: Maybe<Listing_Receipt_Var_Samp_Order_By>
  variance?: Maybe<Listing_Receipt_Variance_Order_By>
}

/** aggregate avg on columns */
export type ListingReceiptAvgFields = {
  __typename?: 'ListingReceiptAvgFields'
  bump?: Maybe<Scalars['Float']>
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  tradeStateBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Boolean expression to filter rows from the table "listing_receipt". All fields are combined with a logical 'AND'. */
export type ListingReceiptBoolExp = {
  _and?: Maybe<Array<ListingReceiptBoolExp>>
  _not?: Maybe<ListingReceiptBoolExp>
  _or?: Maybe<Array<ListingReceiptBoolExp>>
  auctionHouse?: Maybe<StringComparisonExp>
  bookkeeper?: Maybe<StringComparisonExp>
  bump?: Maybe<IntComparisonExp>
  canceledAtOnChain?: Maybe<BigintComparisonExp>
  createdAt?: Maybe<TimestamptzComparisonExp>
  createdAtOnChain?: Maybe<BigintComparisonExp>
  id?: Maybe<StringComparisonExp>
  metadata?: Maybe<StringComparisonExp>
  metadataObject?: Maybe<MetadataBoolExp>
  modifiedAt?: Maybe<TimestamptzComparisonExp>
  price?: Maybe<BigintComparisonExp>
  purchaseReceipt?: Maybe<StringComparisonExp>
  seller?: Maybe<StringComparisonExp>
  slot?: Maybe<BigintComparisonExp>
  tokenSize?: Maybe<BigintComparisonExp>
  tradeState?: Maybe<StringComparisonExp>
  tradeStateBump?: Maybe<IntComparisonExp>
  writeVersion?: Maybe<BigintComparisonExp>
}

/** aggregate max on columns */
export type ListingReceiptMaxFields = {
  __typename?: 'ListingReceiptMaxFields'
  auctionHouse?: Maybe<Scalars['String']>
  bookkeeper?: Maybe<Scalars['String']>
  bump?: Maybe<Scalars['Int']>
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAt?: Maybe<Scalars['timestamptz']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  purchaseReceipt?: Maybe<Scalars['String']>
  seller?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
  tradeState?: Maybe<Scalars['String']>
  tradeStateBump?: Maybe<Scalars['Int']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate min on columns */
export type ListingReceiptMinFields = {
  __typename?: 'ListingReceiptMinFields'
  auctionHouse?: Maybe<Scalars['String']>
  bookkeeper?: Maybe<Scalars['String']>
  bump?: Maybe<Scalars['Int']>
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAt?: Maybe<Scalars['timestamptz']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  purchaseReceipt?: Maybe<Scalars['String']>
  seller?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
  tradeState?: Maybe<Scalars['String']>
  tradeStateBump?: Maybe<Scalars['Int']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** Ordering options when selecting data from "listing_receipt". */
export type ListingReceiptOrderBy = {
  auctionHouse?: Maybe<OrderBy>
  bookkeeper?: Maybe<OrderBy>
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  metadataObject?: Maybe<MetadataOrderBy>
  modifiedAt?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  purchaseReceipt?: Maybe<OrderBy>
  seller?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeState?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** select columns of table "listing_receipt" */
export enum ListingReceiptSelectColumn {
  /** column name */
  AuctionHouse = 'auctionHouse',
  /** column name */
  Bookkeeper = 'bookkeeper',
  /** column name */
  Bump = 'bump',
  /** column name */
  CanceledAtOnChain = 'canceledAtOnChain',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedAtOnChain = 'createdAtOnChain',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ModifiedAt = 'modifiedAt',
  /** column name */
  Price = 'price',
  /** column name */
  PurchaseReceipt = 'purchaseReceipt',
  /** column name */
  Seller = 'seller',
  /** column name */
  Slot = 'slot',
  /** column name */
  TokenSize = 'tokenSize',
  /** column name */
  TradeState = 'tradeState',
  /** column name */
  TradeStateBump = 'tradeStateBump',
  /** column name */
  WriteVersion = 'writeVersion',
}

/** aggregate stddev on columns */
export type ListingReceiptStddevFields = {
  __typename?: 'ListingReceiptStddevFields'
  bump?: Maybe<Scalars['Float']>
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  tradeStateBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_pop on columns */
export type ListingReceiptStddev_PopFields = {
  __typename?: 'ListingReceiptStddev_popFields'
  bump?: Maybe<Scalars['Float']>
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  tradeStateBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_samp on columns */
export type ListingReceiptStddev_SampFields = {
  __typename?: 'ListingReceiptStddev_sampFields'
  bump?: Maybe<Scalars['Float']>
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  tradeStateBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Streaming cursor of the table "listing_receipt" */
export type ListingReceiptStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ListingReceiptStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type ListingReceiptStreamCursorValueInput = {
  auctionHouse?: Maybe<Scalars['String']>
  bookkeeper?: Maybe<Scalars['String']>
  bump?: Maybe<Scalars['Int']>
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAt?: Maybe<Scalars['timestamptz']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  purchaseReceipt?: Maybe<Scalars['String']>
  seller?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
  tradeState?: Maybe<Scalars['String']>
  tradeStateBump?: Maybe<Scalars['Int']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate sum on columns */
export type ListingReceiptSumFields = {
  __typename?: 'ListingReceiptSumFields'
  bump?: Maybe<Scalars['Int']>
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  price?: Maybe<Scalars['bigint']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
  tradeStateBump?: Maybe<Scalars['Int']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate var_pop on columns */
export type ListingReceiptVar_PopFields = {
  __typename?: 'ListingReceiptVar_popFields'
  bump?: Maybe<Scalars['Float']>
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  tradeStateBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate var_samp on columns */
export type ListingReceiptVar_SampFields = {
  __typename?: 'ListingReceiptVar_sampFields'
  bump?: Maybe<Scalars['Float']>
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  tradeStateBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate variance on columns */
export type ListingReceiptVarianceFields = {
  __typename?: 'ListingReceiptVarianceFields'
  bump?: Maybe<Scalars['Float']>
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  tradeStateBump?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** columns and relationships of "listing_with_token" */
export type ListingWithToken = {
  __typename?: 'ListingWithToken'
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  /** An object relationship */
  metadataObject?: Maybe<Metadata>
  mint?: Maybe<Scalars['String']>
  /** An object relationship */
  mintObject?: Maybe<Mint>
  price?: Maybe<Scalars['bigint']>
  seller?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenAccount?: Maybe<Scalars['String']>
  /** An object relationship */
  tokenAccountObject?: Maybe<TokenAccount>
  tokenSize?: Maybe<Scalars['bigint']>
}

/** aggregated selection of "listing_with_token" */
export type ListingWithTokenAggregate = {
  __typename?: 'ListingWithTokenAggregate'
  aggregate?: Maybe<ListingWithTokenAggregateFields>
  nodes: Array<ListingWithToken>
}

/** aggregate fields of "listing_with_token" */
export type ListingWithTokenAggregateFields = {
  __typename?: 'ListingWithTokenAggregateFields'
  avg?: Maybe<ListingWithTokenAvgFields>
  count: Scalars['Int']
  max?: Maybe<ListingWithTokenMaxFields>
  min?: Maybe<ListingWithTokenMinFields>
  stddev?: Maybe<ListingWithTokenStddevFields>
  stddevPop?: Maybe<ListingWithTokenStddev_PopFields>
  stddevSamp?: Maybe<ListingWithTokenStddev_SampFields>
  sum?: Maybe<ListingWithTokenSumFields>
  varPop?: Maybe<ListingWithTokenVar_PopFields>
  varSamp?: Maybe<ListingWithTokenVar_SampFields>
  variance?: Maybe<ListingWithTokenVarianceFields>
}

/** aggregate fields of "listing_with_token" */
export type ListingWithTokenAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ListingWithTokenSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** order by aggregate values of table "listing_with_token" */
export type ListingWithTokenAggregateOrderBy = {
  avg?: Maybe<Listing_With_Token_Avg_Order_By>
  count?: Maybe<OrderBy>
  max?: Maybe<Listing_With_Token_Max_Order_By>
  min?: Maybe<Listing_With_Token_Min_Order_By>
  stddev?: Maybe<Listing_With_Token_Stddev_Order_By>
  stddev_pop?: Maybe<Listing_With_Token_Stddev_Pop_Order_By>
  stddev_samp?: Maybe<Listing_With_Token_Stddev_Samp_Order_By>
  sum?: Maybe<Listing_With_Token_Sum_Order_By>
  var_pop?: Maybe<Listing_With_Token_Var_Pop_Order_By>
  var_samp?: Maybe<Listing_With_Token_Var_Samp_Order_By>
  variance?: Maybe<Listing_With_Token_Variance_Order_By>
}

/** aggregate avg on columns */
export type ListingWithTokenAvgFields = {
  __typename?: 'ListingWithTokenAvgFields'
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
}

/** Boolean expression to filter rows from the table "listing_with_token". All fields are combined with a logical 'AND'. */
export type ListingWithTokenBoolExp = {
  _and?: Maybe<Array<ListingWithTokenBoolExp>>
  _not?: Maybe<ListingWithTokenBoolExp>
  _or?: Maybe<Array<ListingWithTokenBoolExp>>
  createdAtOnChain?: Maybe<BigintComparisonExp>
  id?: Maybe<StringComparisonExp>
  metadata?: Maybe<StringComparisonExp>
  metadataObject?: Maybe<MetadataBoolExp>
  mint?: Maybe<StringComparisonExp>
  mintObject?: Maybe<MintBoolExp>
  price?: Maybe<BigintComparisonExp>
  seller?: Maybe<StringComparisonExp>
  slot?: Maybe<BigintComparisonExp>
  tokenAccount?: Maybe<StringComparisonExp>
  tokenAccountObject?: Maybe<TokenAccountBoolExp>
  tokenSize?: Maybe<BigintComparisonExp>
}

/** aggregate max on columns */
export type ListingWithTokenMaxFields = {
  __typename?: 'ListingWithTokenMaxFields'
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  price?: Maybe<Scalars['bigint']>
  seller?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenAccount?: Maybe<Scalars['String']>
  tokenSize?: Maybe<Scalars['bigint']>
}

/** aggregate min on columns */
export type ListingWithTokenMinFields = {
  __typename?: 'ListingWithTokenMinFields'
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  price?: Maybe<Scalars['bigint']>
  seller?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenAccount?: Maybe<Scalars['String']>
  tokenSize?: Maybe<Scalars['bigint']>
}

/** Ordering options when selecting data from "listing_with_token". */
export type ListingWithTokenOrderBy = {
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  metadataObject?: Maybe<MetadataOrderBy>
  mint?: Maybe<OrderBy>
  mintObject?: Maybe<MintOrderBy>
  price?: Maybe<OrderBy>
  seller?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenAccount?: Maybe<OrderBy>
  tokenAccountObject?: Maybe<TokenAccountOrderBy>
  tokenSize?: Maybe<OrderBy>
}

/** select columns of table "listing_with_token" */
export enum ListingWithTokenSelectColumn {
  /** column name */
  CreatedAtOnChain = 'createdAtOnChain',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Mint = 'mint',
  /** column name */
  Price = 'price',
  /** column name */
  Seller = 'seller',
  /** column name */
  Slot = 'slot',
  /** column name */
  TokenAccount = 'tokenAccount',
  /** column name */
  TokenSize = 'tokenSize',
}

/** aggregate stddev on columns */
export type ListingWithTokenStddevFields = {
  __typename?: 'ListingWithTokenStddevFields'
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
}

/** aggregate stddev_pop on columns */
export type ListingWithTokenStddev_PopFields = {
  __typename?: 'ListingWithTokenStddev_popFields'
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
}

/** aggregate stddev_samp on columns */
export type ListingWithTokenStddev_SampFields = {
  __typename?: 'ListingWithTokenStddev_sampFields'
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
}

/** Streaming cursor of the table "listing_with_token" */
export type ListingWithTokenStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ListingWithTokenStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type ListingWithTokenStreamCursorValueInput = {
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  price?: Maybe<Scalars['bigint']>
  seller?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenAccount?: Maybe<Scalars['String']>
  tokenSize?: Maybe<Scalars['bigint']>
}

/** aggregate sum on columns */
export type ListingWithTokenSumFields = {
  __typename?: 'ListingWithTokenSumFields'
  createdAtOnChain?: Maybe<Scalars['bigint']>
  price?: Maybe<Scalars['bigint']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
}

/** aggregate var_pop on columns */
export type ListingWithTokenVar_PopFields = {
  __typename?: 'ListingWithTokenVar_popFields'
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
}

/** aggregate var_samp on columns */
export type ListingWithTokenVar_SampFields = {
  __typename?: 'ListingWithTokenVar_sampFields'
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
}

/** aggregate variance on columns */
export type ListingWithTokenVarianceFields = {
  __typename?: 'ListingWithTokenVarianceFields'
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
}

/** columns and relationships of "listings" */
export type Listings = {
  __typename?: 'Listings'
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  /** An object relationship */
  metadataObject?: Maybe<Metadata>
  mint?: Maybe<Scalars['String']>
  /** An object relationship */
  mintObject?: Maybe<Mint>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  purchaseReceipt?: Maybe<Scalars['String']>
  seller?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenAccount?: Maybe<Scalars['String']>
  /** An object relationship */
  tokenAccountObject?: Maybe<TokenAccount>
  tokenSize?: Maybe<Scalars['bigint']>
}

/** aggregated selection of "listings" */
export type ListingsAggregate = {
  __typename?: 'ListingsAggregate'
  aggregate?: Maybe<ListingsAggregateFields>
  nodes: Array<Listings>
}

/** aggregate fields of "listings" */
export type ListingsAggregateFields = {
  __typename?: 'ListingsAggregateFields'
  avg?: Maybe<ListingsAvgFields>
  count: Scalars['Int']
  max?: Maybe<ListingsMaxFields>
  min?: Maybe<ListingsMinFields>
  stddev?: Maybe<ListingsStddevFields>
  stddevPop?: Maybe<ListingsStddev_PopFields>
  stddevSamp?: Maybe<ListingsStddev_SampFields>
  sum?: Maybe<ListingsSumFields>
  varPop?: Maybe<ListingsVar_PopFields>
  varSamp?: Maybe<ListingsVar_SampFields>
  variance?: Maybe<ListingsVarianceFields>
}

/** aggregate fields of "listings" */
export type ListingsAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ListingsSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** aggregate avg on columns */
export type ListingsAvgFields = {
  __typename?: 'ListingsAvgFields'
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
}

/** Boolean expression to filter rows from the table "listings". All fields are combined with a logical 'AND'. */
export type ListingsBoolExp = {
  _and?: Maybe<Array<ListingsBoolExp>>
  _not?: Maybe<ListingsBoolExp>
  _or?: Maybe<Array<ListingsBoolExp>>
  canceledAtOnChain?: Maybe<BigintComparisonExp>
  createdAtOnChain?: Maybe<BigintComparisonExp>
  id?: Maybe<StringComparisonExp>
  metadata?: Maybe<StringComparisonExp>
  metadataObject?: Maybe<MetadataBoolExp>
  mint?: Maybe<StringComparisonExp>
  mintObject?: Maybe<MintBoolExp>
  modifiedAt?: Maybe<TimestamptzComparisonExp>
  price?: Maybe<BigintComparisonExp>
  purchaseReceipt?: Maybe<StringComparisonExp>
  seller?: Maybe<StringComparisonExp>
  slot?: Maybe<BigintComparisonExp>
  tokenAccount?: Maybe<StringComparisonExp>
  tokenAccountObject?: Maybe<TokenAccountBoolExp>
  tokenSize?: Maybe<BigintComparisonExp>
}

/** aggregate max on columns */
export type ListingsMaxFields = {
  __typename?: 'ListingsMaxFields'
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  purchaseReceipt?: Maybe<Scalars['String']>
  seller?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenAccount?: Maybe<Scalars['String']>
  tokenSize?: Maybe<Scalars['bigint']>
}

/** aggregate min on columns */
export type ListingsMinFields = {
  __typename?: 'ListingsMinFields'
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  purchaseReceipt?: Maybe<Scalars['String']>
  seller?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenAccount?: Maybe<Scalars['String']>
  tokenSize?: Maybe<Scalars['bigint']>
}

/** Ordering options when selecting data from "listings". */
export type ListingsOrderBy = {
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  metadataObject?: Maybe<MetadataOrderBy>
  mint?: Maybe<OrderBy>
  mintObject?: Maybe<MintOrderBy>
  modifiedAt?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  purchaseReceipt?: Maybe<OrderBy>
  seller?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenAccount?: Maybe<OrderBy>
  tokenAccountObject?: Maybe<TokenAccountOrderBy>
  tokenSize?: Maybe<OrderBy>
}

/** select columns of table "listings" */
export enum ListingsSelectColumn {
  /** column name */
  CanceledAtOnChain = 'canceledAtOnChain',
  /** column name */
  CreatedAtOnChain = 'createdAtOnChain',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Mint = 'mint',
  /** column name */
  ModifiedAt = 'modifiedAt',
  /** column name */
  Price = 'price',
  /** column name */
  PurchaseReceipt = 'purchaseReceipt',
  /** column name */
  Seller = 'seller',
  /** column name */
  Slot = 'slot',
  /** column name */
  TokenAccount = 'tokenAccount',
  /** column name */
  TokenSize = 'tokenSize',
}

/** aggregate stddev on columns */
export type ListingsStddevFields = {
  __typename?: 'ListingsStddevFields'
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
}

/** aggregate stddev_pop on columns */
export type ListingsStddev_PopFields = {
  __typename?: 'ListingsStddev_popFields'
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
}

/** aggregate stddev_samp on columns */
export type ListingsStddev_SampFields = {
  __typename?: 'ListingsStddev_sampFields'
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
}

/** Streaming cursor of the table "listings" */
export type ListingsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ListingsStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type ListingsStreamCursorValueInput = {
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  purchaseReceipt?: Maybe<Scalars['String']>
  seller?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenAccount?: Maybe<Scalars['String']>
  tokenSize?: Maybe<Scalars['bigint']>
}

/** aggregate sum on columns */
export type ListingsSumFields = {
  __typename?: 'ListingsSumFields'
  canceledAtOnChain?: Maybe<Scalars['bigint']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  price?: Maybe<Scalars['bigint']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
}

/** aggregate var_pop on columns */
export type ListingsVar_PopFields = {
  __typename?: 'ListingsVar_popFields'
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
}

/** aggregate var_samp on columns */
export type ListingsVar_SampFields = {
  __typename?: 'ListingsVar_sampFields'
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
}

/** aggregate variance on columns */
export type ListingsVarianceFields = {
  __typename?: 'ListingsVarianceFields'
  canceledAtOnChain?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
}

/** columns and relationships of "metadata" */
export type Metadata = {
  __typename?: 'Metadata'
  /** An array relationship */
  bidReceipts: Array<BidReceipt>
  /** An aggregate relationship */
  bidReceiptsAggregate: BidReceiptAggregate
  collectionKey?: Maybe<Scalars['String']>
  collectionVerified?: Maybe<Scalars['Boolean']>
  createdAt: Scalars['timestamptz']
  /** An array relationship */
  creators: Array<Creator>
  /** An aggregate relationship */
  creatorsAggregate: CreatorAggregate
  /** An object relationship */
  editionMetadata?: Maybe<EditionMetadata>
  editionNonce?: Maybe<Scalars['Int']>
  id: Scalars['String']
  isMutable: Scalars['Boolean']
  key: Scalars['String']
  /** An array relationship */
  listingReceipts: Array<ListingReceipt>
  /** An aggregate relationship */
  listingReceiptsAggregate: ListingReceiptAggregate
  mint: Scalars['String']
  /** An object relationship */
  mintObject?: Maybe<Mint>
  modifiedAt: Scalars['timestamptz']
  name: Scalars['String']
  primarySaleHappened: Scalars['Boolean']
  /** An array relationship */
  purchaseReceipts: Array<PurchaseReceipt>
  /** An aggregate relationship */
  purchaseReceiptsAggregate: PurchaseReceiptAggregate
  sellerFeeBasisPoints: Scalars['Int']
  slot: Scalars['bigint']
  symbol: Scalars['String']
  tokenStandard?: Maybe<Scalars['String']>
  updateAuthority: Scalars['String']
  uri: Scalars['String']
  usesRemaining?: Maybe<Scalars['bigint']>
  usesTotal?: Maybe<Scalars['bigint']>
  usesUseMethod?: Maybe<Scalars['String']>
  writeVersion: Scalars['bigint']
}

/** columns and relationships of "metadata" */
export type MetadataBidReceiptsArgs = {
  distinctOn?: Maybe<Array<BidReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<BidReceiptOrderBy>>
  where?: Maybe<BidReceiptBoolExp>
}

/** columns and relationships of "metadata" */
export type MetadataBidReceiptsAggregateArgs = {
  distinctOn?: Maybe<Array<BidReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<BidReceiptOrderBy>>
  where?: Maybe<BidReceiptBoolExp>
}

/** columns and relationships of "metadata" */
export type MetadataCreatorsArgs = {
  distinctOn?: Maybe<Array<CreatorSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<CreatorOrderBy>>
  where?: Maybe<CreatorBoolExp>
}

/** columns and relationships of "metadata" */
export type MetadataCreatorsAggregateArgs = {
  distinctOn?: Maybe<Array<CreatorSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<CreatorOrderBy>>
  where?: Maybe<CreatorBoolExp>
}

/** columns and relationships of "metadata" */
export type MetadataListingReceiptsArgs = {
  distinctOn?: Maybe<Array<ListingReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingReceiptOrderBy>>
  where?: Maybe<ListingReceiptBoolExp>
}

/** columns and relationships of "metadata" */
export type MetadataListingReceiptsAggregateArgs = {
  distinctOn?: Maybe<Array<ListingReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingReceiptOrderBy>>
  where?: Maybe<ListingReceiptBoolExp>
}

/** columns and relationships of "metadata" */
export type MetadataPurchaseReceiptsArgs = {
  distinctOn?: Maybe<Array<PurchaseReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<PurchaseReceiptOrderBy>>
  where?: Maybe<PurchaseReceiptBoolExp>
}

/** columns and relationships of "metadata" */
export type MetadataPurchaseReceiptsAggregateArgs = {
  distinctOn?: Maybe<Array<PurchaseReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<PurchaseReceiptOrderBy>>
  where?: Maybe<PurchaseReceiptBoolExp>
}

/** aggregated selection of "metadata" */
export type MetadataAggregate = {
  __typename?: 'MetadataAggregate'
  aggregate?: Maybe<MetadataAggregateFields>
  nodes: Array<Metadata>
}

/** aggregate fields of "metadata" */
export type MetadataAggregateFields = {
  __typename?: 'MetadataAggregateFields'
  avg?: Maybe<MetadataAvgFields>
  count: Scalars['Int']
  max?: Maybe<MetadataMaxFields>
  min?: Maybe<MetadataMinFields>
  stddev?: Maybe<MetadataStddevFields>
  stddevPop?: Maybe<MetadataStddev_PopFields>
  stddevSamp?: Maybe<MetadataStddev_SampFields>
  sum?: Maybe<MetadataSumFields>
  varPop?: Maybe<MetadataVar_PopFields>
  varSamp?: Maybe<MetadataVar_SampFields>
  variance?: Maybe<MetadataVarianceFields>
}

/** aggregate fields of "metadata" */
export type MetadataAggregateFieldsCountArgs = {
  columns?: Maybe<Array<MetadataSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** order by aggregate values of table "metadata" */
export type MetadataAggregateOrderBy = {
  avg?: Maybe<Metadata_Avg_Order_By>
  count?: Maybe<OrderBy>
  max?: Maybe<Metadata_Max_Order_By>
  min?: Maybe<Metadata_Min_Order_By>
  stddev?: Maybe<Metadata_Stddev_Order_By>
  stddev_pop?: Maybe<Metadata_Stddev_Pop_Order_By>
  stddev_samp?: Maybe<Metadata_Stddev_Samp_Order_By>
  sum?: Maybe<Metadata_Sum_Order_By>
  var_pop?: Maybe<Metadata_Var_Pop_Order_By>
  var_samp?: Maybe<Metadata_Var_Samp_Order_By>
  variance?: Maybe<Metadata_Variance_Order_By>
}

/** aggregate avg on columns */
export type MetadataAvgFields = {
  __typename?: 'MetadataAvgFields'
  editionNonce?: Maybe<Scalars['Float']>
  sellerFeeBasisPoints?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  usesRemaining?: Maybe<Scalars['Float']>
  usesTotal?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Boolean expression to filter rows from the table "metadata". All fields are combined with a logical 'AND'. */
export type MetadataBoolExp = {
  _and?: Maybe<Array<MetadataBoolExp>>
  _not?: Maybe<MetadataBoolExp>
  _or?: Maybe<Array<MetadataBoolExp>>
  bidReceipts?: Maybe<BidReceiptBoolExp>
  bidReceipts_aggregate?: Maybe<Bid_Receipt_Aggregate_Bool_Exp>
  collectionKey?: Maybe<StringComparisonExp>
  collectionVerified?: Maybe<BooleanComparisonExp>
  createdAt?: Maybe<TimestamptzComparisonExp>
  creators?: Maybe<CreatorBoolExp>
  creators_aggregate?: Maybe<Creator_Aggregate_Bool_Exp>
  editionMetadata?: Maybe<EditionMetadataBoolExp>
  editionNonce?: Maybe<IntComparisonExp>
  id?: Maybe<StringComparisonExp>
  isMutable?: Maybe<BooleanComparisonExp>
  key?: Maybe<StringComparisonExp>
  listingReceipts?: Maybe<ListingReceiptBoolExp>
  listingReceipts_aggregate?: Maybe<Listing_Receipt_Aggregate_Bool_Exp>
  mint?: Maybe<StringComparisonExp>
  mintObject?: Maybe<MintBoolExp>
  modifiedAt?: Maybe<TimestamptzComparisonExp>
  name?: Maybe<StringComparisonExp>
  primarySaleHappened?: Maybe<BooleanComparisonExp>
  purchaseReceipts?: Maybe<PurchaseReceiptBoolExp>
  purchaseReceipts_aggregate?: Maybe<Purchase_Receipt_Aggregate_Bool_Exp>
  sellerFeeBasisPoints?: Maybe<IntComparisonExp>
  slot?: Maybe<BigintComparisonExp>
  symbol?: Maybe<StringComparisonExp>
  tokenStandard?: Maybe<StringComparisonExp>
  updateAuthority?: Maybe<StringComparisonExp>
  uri?: Maybe<StringComparisonExp>
  usesRemaining?: Maybe<BigintComparisonExp>
  usesTotal?: Maybe<BigintComparisonExp>
  usesUseMethod?: Maybe<StringComparisonExp>
  writeVersion?: Maybe<BigintComparisonExp>
}

/** aggregate max on columns */
export type MetadataMaxFields = {
  __typename?: 'MetadataMaxFields'
  collectionKey?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  editionNonce?: Maybe<Scalars['Int']>
  id?: Maybe<Scalars['String']>
  key?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  name?: Maybe<Scalars['String']>
  sellerFeeBasisPoints?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  symbol?: Maybe<Scalars['String']>
  tokenStandard?: Maybe<Scalars['String']>
  updateAuthority?: Maybe<Scalars['String']>
  uri?: Maybe<Scalars['String']>
  usesRemaining?: Maybe<Scalars['bigint']>
  usesTotal?: Maybe<Scalars['bigint']>
  usesUseMethod?: Maybe<Scalars['String']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate min on columns */
export type MetadataMinFields = {
  __typename?: 'MetadataMinFields'
  collectionKey?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  editionNonce?: Maybe<Scalars['Int']>
  id?: Maybe<Scalars['String']>
  key?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  name?: Maybe<Scalars['String']>
  sellerFeeBasisPoints?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  symbol?: Maybe<Scalars['String']>
  tokenStandard?: Maybe<Scalars['String']>
  updateAuthority?: Maybe<Scalars['String']>
  uri?: Maybe<Scalars['String']>
  usesRemaining?: Maybe<Scalars['bigint']>
  usesTotal?: Maybe<Scalars['bigint']>
  usesUseMethod?: Maybe<Scalars['String']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** Ordering options when selecting data from "metadata". */
export type MetadataOrderBy = {
  bidReceiptsAggregate?: Maybe<BidReceiptAggregateOrderBy>
  collectionKey?: Maybe<OrderBy>
  collectionVerified?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  creatorsAggregate?: Maybe<CreatorAggregateOrderBy>
  editionMetadata?: Maybe<EditionMetadataOrderBy>
  editionNonce?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  isMutable?: Maybe<OrderBy>
  key?: Maybe<OrderBy>
  listingReceiptsAggregate?: Maybe<ListingReceiptAggregateOrderBy>
  mint?: Maybe<OrderBy>
  mintObject?: Maybe<MintOrderBy>
  modifiedAt?: Maybe<OrderBy>
  name?: Maybe<OrderBy>
  primarySaleHappened?: Maybe<OrderBy>
  purchaseReceiptsAggregate?: Maybe<PurchaseReceiptAggregateOrderBy>
  sellerFeeBasisPoints?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  symbol?: Maybe<OrderBy>
  tokenStandard?: Maybe<OrderBy>
  updateAuthority?: Maybe<OrderBy>
  uri?: Maybe<OrderBy>
  usesRemaining?: Maybe<OrderBy>
  usesTotal?: Maybe<OrderBy>
  usesUseMethod?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** select columns of table "metadata" */
export enum MetadataSelectColumn {
  /** column name */
  CollectionKey = 'collectionKey',
  /** column name */
  CollectionVerified = 'collectionVerified',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EditionNonce = 'editionNonce',
  /** column name */
  Id = 'id',
  /** column name */
  IsMutable = 'isMutable',
  /** column name */
  Key = 'key',
  /** column name */
  Mint = 'mint',
  /** column name */
  ModifiedAt = 'modifiedAt',
  /** column name */
  Name = 'name',
  /** column name */
  PrimarySaleHappened = 'primarySaleHappened',
  /** column name */
  SellerFeeBasisPoints = 'sellerFeeBasisPoints',
  /** column name */
  Slot = 'slot',
  /** column name */
  Symbol = 'symbol',
  /** column name */
  TokenStandard = 'tokenStandard',
  /** column name */
  UpdateAuthority = 'updateAuthority',
  /** column name */
  Uri = 'uri',
  /** column name */
  UsesRemaining = 'usesRemaining',
  /** column name */
  UsesTotal = 'usesTotal',
  /** column name */
  UsesUseMethod = 'usesUseMethod',
  /** column name */
  WriteVersion = 'writeVersion',
}

/** aggregate stddev on columns */
export type MetadataStddevFields = {
  __typename?: 'MetadataStddevFields'
  editionNonce?: Maybe<Scalars['Float']>
  sellerFeeBasisPoints?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  usesRemaining?: Maybe<Scalars['Float']>
  usesTotal?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_pop on columns */
export type MetadataStddev_PopFields = {
  __typename?: 'MetadataStddev_popFields'
  editionNonce?: Maybe<Scalars['Float']>
  sellerFeeBasisPoints?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  usesRemaining?: Maybe<Scalars['Float']>
  usesTotal?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_samp on columns */
export type MetadataStddev_SampFields = {
  __typename?: 'MetadataStddev_sampFields'
  editionNonce?: Maybe<Scalars['Float']>
  sellerFeeBasisPoints?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  usesRemaining?: Maybe<Scalars['Float']>
  usesTotal?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Streaming cursor of the table "metadata" */
export type MetadataStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MetadataStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type MetadataStreamCursorValueInput = {
  collectionKey?: Maybe<Scalars['String']>
  collectionVerified?: Maybe<Scalars['Boolean']>
  createdAt?: Maybe<Scalars['timestamptz']>
  editionNonce?: Maybe<Scalars['Int']>
  id?: Maybe<Scalars['String']>
  isMutable?: Maybe<Scalars['Boolean']>
  key?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  name?: Maybe<Scalars['String']>
  primarySaleHappened?: Maybe<Scalars['Boolean']>
  sellerFeeBasisPoints?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  symbol?: Maybe<Scalars['String']>
  tokenStandard?: Maybe<Scalars['String']>
  updateAuthority?: Maybe<Scalars['String']>
  uri?: Maybe<Scalars['String']>
  usesRemaining?: Maybe<Scalars['bigint']>
  usesTotal?: Maybe<Scalars['bigint']>
  usesUseMethod?: Maybe<Scalars['String']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate sum on columns */
export type MetadataSumFields = {
  __typename?: 'MetadataSumFields'
  editionNonce?: Maybe<Scalars['Int']>
  sellerFeeBasisPoints?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  usesRemaining?: Maybe<Scalars['bigint']>
  usesTotal?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate var_pop on columns */
export type MetadataVar_PopFields = {
  __typename?: 'MetadataVar_popFields'
  editionNonce?: Maybe<Scalars['Float']>
  sellerFeeBasisPoints?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  usesRemaining?: Maybe<Scalars['Float']>
  usesTotal?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate var_samp on columns */
export type MetadataVar_SampFields = {
  __typename?: 'MetadataVar_sampFields'
  editionNonce?: Maybe<Scalars['Float']>
  sellerFeeBasisPoints?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  usesRemaining?: Maybe<Scalars['Float']>
  usesTotal?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate variance on columns */
export type MetadataVarianceFields = {
  __typename?: 'MetadataVarianceFields'
  editionNonce?: Maybe<Scalars['Float']>
  sellerFeeBasisPoints?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  usesRemaining?: Maybe<Scalars['Float']>
  usesTotal?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** columns and relationships of "milestones" */
export type Milestones = {
  __typename?: 'Milestones'
  endTime?: Maybe<Scalars['timestamptz']>
  mint: Scalars['String']
  /** An object relationship */
  mintObject?: Maybe<Mint>
  nextMilestone: Scalars['Int']
}

/** aggregated selection of "milestones" */
export type MilestonesAggregate = {
  __typename?: 'MilestonesAggregate'
  aggregate?: Maybe<MilestonesAggregateFields>
  nodes: Array<Milestones>
}

/** aggregate fields of "milestones" */
export type MilestonesAggregateFields = {
  __typename?: 'MilestonesAggregateFields'
  avg?: Maybe<MilestonesAvgFields>
  count: Scalars['Int']
  max?: Maybe<MilestonesMaxFields>
  min?: Maybe<MilestonesMinFields>
  stddev?: Maybe<MilestonesStddevFields>
  stddevPop?: Maybe<MilestonesStddev_PopFields>
  stddevSamp?: Maybe<MilestonesStddev_SampFields>
  sum?: Maybe<MilestonesSumFields>
  varPop?: Maybe<MilestonesVar_PopFields>
  varSamp?: Maybe<MilestonesVar_SampFields>
  variance?: Maybe<MilestonesVarianceFields>
}

/** aggregate fields of "milestones" */
export type MilestonesAggregateFieldsCountArgs = {
  columns?: Maybe<Array<MilestonesSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** aggregate avg on columns */
export type MilestonesAvgFields = {
  __typename?: 'MilestonesAvgFields'
  nextMilestone?: Maybe<Scalars['Float']>
}

/** Boolean expression to filter rows from the table "milestones". All fields are combined with a logical 'AND'. */
export type MilestonesBoolExp = {
  _and?: Maybe<Array<MilestonesBoolExp>>
  _not?: Maybe<MilestonesBoolExp>
  _or?: Maybe<Array<MilestonesBoolExp>>
  endTime?: Maybe<TimestamptzComparisonExp>
  mint?: Maybe<StringComparisonExp>
  mintObject?: Maybe<MintBoolExp>
  nextMilestone?: Maybe<IntComparisonExp>
}

/** aggregate max on columns */
export type MilestonesMaxFields = {
  __typename?: 'MilestonesMaxFields'
  endTime?: Maybe<Scalars['timestamptz']>
  mint?: Maybe<Scalars['String']>
  nextMilestone?: Maybe<Scalars['Int']>
}

/** aggregate min on columns */
export type MilestonesMinFields = {
  __typename?: 'MilestonesMinFields'
  endTime?: Maybe<Scalars['timestamptz']>
  mint?: Maybe<Scalars['String']>
  nextMilestone?: Maybe<Scalars['Int']>
}

/** Ordering options when selecting data from "milestones". */
export type MilestonesOrderBy = {
  endTime?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  mintObject?: Maybe<MintOrderBy>
  nextMilestone?: Maybe<OrderBy>
}

/** select columns of table "milestones" */
export enum MilestonesSelectColumn {
  /** column name */
  EndTime = 'endTime',
  /** column name */
  Mint = 'mint',
  /** column name */
  NextMilestone = 'nextMilestone',
}

/** aggregate stddev on columns */
export type MilestonesStddevFields = {
  __typename?: 'MilestonesStddevFields'
  nextMilestone?: Maybe<Scalars['Float']>
}

/** aggregate stddev_pop on columns */
export type MilestonesStddev_PopFields = {
  __typename?: 'MilestonesStddev_popFields'
  nextMilestone?: Maybe<Scalars['Float']>
}

/** aggregate stddev_samp on columns */
export type MilestonesStddev_SampFields = {
  __typename?: 'MilestonesStddev_sampFields'
  nextMilestone?: Maybe<Scalars['Float']>
}

/** Streaming cursor of the table "milestones" */
export type MilestonesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MilestonesStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type MilestonesStreamCursorValueInput = {
  endTime?: Maybe<Scalars['timestamptz']>
  mint?: Maybe<Scalars['String']>
  nextMilestone?: Maybe<Scalars['Int']>
}

/** aggregate sum on columns */
export type MilestonesSumFields = {
  __typename?: 'MilestonesSumFields'
  nextMilestone?: Maybe<Scalars['Int']>
}

/** aggregate var_pop on columns */
export type MilestonesVar_PopFields = {
  __typename?: 'MilestonesVar_popFields'
  nextMilestone?: Maybe<Scalars['Float']>
}

/** aggregate var_samp on columns */
export type MilestonesVar_SampFields = {
  __typename?: 'MilestonesVar_sampFields'
  nextMilestone?: Maybe<Scalars['Float']>
}

/** aggregate variance on columns */
export type MilestonesVarianceFields = {
  __typename?: 'MilestonesVarianceFields'
  nextMilestone?: Maybe<Scalars['Float']>
}

/** columns and relationships of "mint" */
export type Mint = {
  __typename?: 'Mint'
  createdAt?: Maybe<Scalars['timestamptz']>
  decimals: Scalars['Int']
  /** An object relationship */
  dropTime?: Maybe<DropTimes>
  /** An object relationship */
  editionMetadata?: Maybe<EditionMetadata>
  /** An object relationship */
  floorPriceObject?: Maybe<FloorPrice>
  freezeAuthority?: Maybe<Scalars['String']>
  id: Scalars['String']
  isInitialized: Scalars['Boolean']
  /** An array relationship */
  listingsWithToken: Array<ListingWithToken>
  /** An aggregate relationship */
  listingsWithTokenAggregate: ListingWithTokenAggregate
  /** An object relationship */
  milestones?: Maybe<Milestones>
  mintAuthority?: Maybe<Scalars['String']>
  /** An array relationship */
  mintRelations: Array<MintRelation>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  /** An array relationship */
  primaryReceipts: Array<PrimaryReceipt>
  /** An aggregate relationship */
  primaryReceiptsAggregate: PrimaryReceiptAggregate
  slot: Scalars['bigint']
  supply: Scalars['bigint']
  /** An array relationship */
  tokenAccounts: Array<TokenAccount>
  /** An aggregate relationship */
  tokenAccountsAggregate: TokenAccountAggregate
  writeVersion: Scalars['bigint']
}

/** columns and relationships of "mint" */
export type MintListingsWithTokenArgs = {
  distinctOn?: Maybe<Array<ListingWithTokenSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingWithTokenOrderBy>>
  where?: Maybe<ListingWithTokenBoolExp>
}

/** columns and relationships of "mint" */
export type MintListingsWithTokenAggregateArgs = {
  distinctOn?: Maybe<Array<ListingWithTokenSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingWithTokenOrderBy>>
  where?: Maybe<ListingWithTokenBoolExp>
}

/** columns and relationships of "mint" */
export type MintMintRelationsArgs = {
  distinctOn?: Maybe<Array<MintRelationSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MintRelationOrderBy>>
  where?: Maybe<MintRelationBoolExp>
}

/** columns and relationships of "mint" */
export type MintPrimaryReceiptsArgs = {
  distinctOn?: Maybe<Array<PrimaryReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<PrimaryReceiptOrderBy>>
  where?: Maybe<PrimaryReceiptBoolExp>
}

/** columns and relationships of "mint" */
export type MintPrimaryReceiptsAggregateArgs = {
  distinctOn?: Maybe<Array<PrimaryReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<PrimaryReceiptOrderBy>>
  where?: Maybe<PrimaryReceiptBoolExp>
}

/** columns and relationships of "mint" */
export type MintTokenAccountsArgs = {
  distinctOn?: Maybe<Array<TokenAccountSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<TokenAccountOrderBy>>
  where?: Maybe<TokenAccountBoolExp>
}

/** columns and relationships of "mint" */
export type MintTokenAccountsAggregateArgs = {
  distinctOn?: Maybe<Array<TokenAccountSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<TokenAccountOrderBy>>
  where?: Maybe<TokenAccountBoolExp>
}

/** aggregated selection of "mint" */
export type MintAggregate = {
  __typename?: 'MintAggregate'
  aggregate?: Maybe<MintAggregateFields>
  nodes: Array<Mint>
}

/** aggregate fields of "mint" */
export type MintAggregateFields = {
  __typename?: 'MintAggregateFields'
  avg?: Maybe<MintAvgFields>
  count: Scalars['Int']
  max?: Maybe<MintMaxFields>
  min?: Maybe<MintMinFields>
  stddev?: Maybe<MintStddevFields>
  stddevPop?: Maybe<MintStddev_PopFields>
  stddevSamp?: Maybe<MintStddev_SampFields>
  sum?: Maybe<MintSumFields>
  varPop?: Maybe<MintVar_PopFields>
  varSamp?: Maybe<MintVar_SampFields>
  variance?: Maybe<MintVarianceFields>
}

/** aggregate fields of "mint" */
export type MintAggregateFieldsCountArgs = {
  columns?: Maybe<Array<MintSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** aggregate avg on columns */
export type MintAvgFields = {
  __typename?: 'MintAvgFields'
  decimals?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  supply?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Boolean expression to filter rows from the table "mint". All fields are combined with a logical 'AND'. */
export type MintBoolExp = {
  _and?: Maybe<Array<MintBoolExp>>
  _not?: Maybe<MintBoolExp>
  _or?: Maybe<Array<MintBoolExp>>
  createdAt?: Maybe<TimestamptzComparisonExp>
  decimals?: Maybe<IntComparisonExp>
  dropTime?: Maybe<DropTimesBoolExp>
  editionMetadata?: Maybe<EditionMetadataBoolExp>
  floorPriceObject?: Maybe<FloorPriceBoolExp>
  freezeAuthority?: Maybe<StringComparisonExp>
  id?: Maybe<StringComparisonExp>
  isInitialized?: Maybe<BooleanComparisonExp>
  listingsWithToken?: Maybe<ListingWithTokenBoolExp>
  listingsWithToken_aggregate?: Maybe<Listing_With_Token_Aggregate_Bool_Exp>
  milestones?: Maybe<MilestonesBoolExp>
  mintAuthority?: Maybe<StringComparisonExp>
  mintRelations?: Maybe<MintRelationBoolExp>
  modifiedAt?: Maybe<TimestamptzComparisonExp>
  primaryReceipts?: Maybe<PrimaryReceiptBoolExp>
  primaryReceipts_aggregate?: Maybe<Primary_Receipt_Aggregate_Bool_Exp>
  slot?: Maybe<BigintComparisonExp>
  supply?: Maybe<BigintComparisonExp>
  tokenAccounts?: Maybe<TokenAccountBoolExp>
  tokenAccounts_aggregate?: Maybe<Token_Account_Aggregate_Bool_Exp>
  writeVersion?: Maybe<BigintComparisonExp>
}

/** aggregate max on columns */
export type MintMaxFields = {
  __typename?: 'MintMaxFields'
  createdAt?: Maybe<Scalars['timestamptz']>
  decimals?: Maybe<Scalars['Int']>
  freezeAuthority?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  mintAuthority?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  slot?: Maybe<Scalars['bigint']>
  supply?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate min on columns */
export type MintMinFields = {
  __typename?: 'MintMinFields'
  createdAt?: Maybe<Scalars['timestamptz']>
  decimals?: Maybe<Scalars['Int']>
  freezeAuthority?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  mintAuthority?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  slot?: Maybe<Scalars['bigint']>
  supply?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** Ordering options when selecting data from "mint". */
export type MintOrderBy = {
  createdAt?: Maybe<OrderBy>
  decimals?: Maybe<OrderBy>
  dropTime?: Maybe<DropTimesOrderBy>
  editionMetadata?: Maybe<EditionMetadataOrderBy>
  floorPriceObject?: Maybe<FloorPriceOrderBy>
  freezeAuthority?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  isInitialized?: Maybe<OrderBy>
  listingsWithTokenAggregate?: Maybe<ListingWithTokenAggregateOrderBy>
  milestones?: Maybe<MilestonesOrderBy>
  mintAuthority?: Maybe<OrderBy>
  mintRelationsAggregate?: Maybe<MintRelationAggregateOrderBy>
  modifiedAt?: Maybe<OrderBy>
  primaryReceiptsAggregate?: Maybe<PrimaryReceiptAggregateOrderBy>
  slot?: Maybe<OrderBy>
  supply?: Maybe<OrderBy>
  tokenAccountsAggregate?: Maybe<TokenAccountAggregateOrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** columns and relationships of "mint_relation" */
export type MintRelation = {
  __typename?: 'MintRelation'
  amountSum?: Maybe<Scalars['numeric']>
  createdAt?: Maybe<Scalars['timestamptz']>
  mint?: Maybe<Scalars['String']>
  ownerCount?: Maybe<Scalars['bigint']>
  relatedMint?: Maybe<Scalars['String']>
  /** An object relationship */
  relatedMintObject?: Maybe<Mint>
}

/** order by aggregate values of table "mint_relation" */
export type MintRelationAggregateOrderBy = {
  avg?: Maybe<Mint_Relation_Avg_Order_By>
  count?: Maybe<OrderBy>
  max?: Maybe<Mint_Relation_Max_Order_By>
  min?: Maybe<Mint_Relation_Min_Order_By>
  stddev?: Maybe<Mint_Relation_Stddev_Order_By>
  stddev_pop?: Maybe<Mint_Relation_Stddev_Pop_Order_By>
  stddev_samp?: Maybe<Mint_Relation_Stddev_Samp_Order_By>
  sum?: Maybe<Mint_Relation_Sum_Order_By>
  var_pop?: Maybe<Mint_Relation_Var_Pop_Order_By>
  var_samp?: Maybe<Mint_Relation_Var_Samp_Order_By>
  variance?: Maybe<Mint_Relation_Variance_Order_By>
}

/** Boolean expression to filter rows from the table "mint_relation". All fields are combined with a logical 'AND'. */
export type MintRelationBoolExp = {
  _and?: Maybe<Array<MintRelationBoolExp>>
  _not?: Maybe<MintRelationBoolExp>
  _or?: Maybe<Array<MintRelationBoolExp>>
  amountSum?: Maybe<NumericComparisonExp>
  createdAt?: Maybe<TimestamptzComparisonExp>
  mint?: Maybe<StringComparisonExp>
  ownerCount?: Maybe<BigintComparisonExp>
  relatedMint?: Maybe<StringComparisonExp>
  relatedMintObject?: Maybe<MintBoolExp>
}

/** Ordering options when selecting data from "mint_relation". */
export type MintRelationOrderBy = {
  amountSum?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  ownerCount?: Maybe<OrderBy>
  relatedMint?: Maybe<OrderBy>
  relatedMintObject?: Maybe<MintOrderBy>
}

/** select columns of table "mint_relation" */
export enum MintRelationSelectColumn {
  /** column name */
  AmountSum = 'amountSum',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Mint = 'mint',
  /** column name */
  OwnerCount = 'ownerCount',
  /** column name */
  RelatedMint = 'relatedMint',
}

/** Streaming cursor of the table "mint_relation" */
export type MintRelationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MintRelationStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type MintRelationStreamCursorValueInput = {
  amountSum?: Maybe<Scalars['numeric']>
  createdAt?: Maybe<Scalars['timestamptz']>
  mint?: Maybe<Scalars['String']>
  ownerCount?: Maybe<Scalars['bigint']>
  relatedMint?: Maybe<Scalars['String']>
}

/** select columns of table "mint" */
export enum MintSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Decimals = 'decimals',
  /** column name */
  FreezeAuthority = 'freezeAuthority',
  /** column name */
  Id = 'id',
  /** column name */
  IsInitialized = 'isInitialized',
  /** column name */
  MintAuthority = 'mintAuthority',
  /** column name */
  ModifiedAt = 'modifiedAt',
  /** column name */
  Slot = 'slot',
  /** column name */
  Supply = 'supply',
  /** column name */
  WriteVersion = 'writeVersion',
}

/** aggregate stddev on columns */
export type MintStddevFields = {
  __typename?: 'MintStddevFields'
  decimals?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  supply?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_pop on columns */
export type MintStddev_PopFields = {
  __typename?: 'MintStddev_popFields'
  decimals?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  supply?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_samp on columns */
export type MintStddev_SampFields = {
  __typename?: 'MintStddev_sampFields'
  decimals?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  supply?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Streaming cursor of the table "mint" */
export type MintStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MintStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type MintStreamCursorValueInput = {
  createdAt?: Maybe<Scalars['timestamptz']>
  decimals?: Maybe<Scalars['Int']>
  freezeAuthority?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  isInitialized?: Maybe<Scalars['Boolean']>
  mintAuthority?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  slot?: Maybe<Scalars['bigint']>
  supply?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate sum on columns */
export type MintSumFields = {
  __typename?: 'MintSumFields'
  decimals?: Maybe<Scalars['Int']>
  slot?: Maybe<Scalars['bigint']>
  supply?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate var_pop on columns */
export type MintVar_PopFields = {
  __typename?: 'MintVar_popFields'
  decimals?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  supply?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate var_samp on columns */
export type MintVar_SampFields = {
  __typename?: 'MintVar_sampFields'
  decimals?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  supply?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate variance on columns */
export type MintVarianceFields = {
  __typename?: 'MintVarianceFields'
  decimals?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  supply?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: Maybe<Scalars['numeric']>
  _gt?: Maybe<Scalars['numeric']>
  _gte?: Maybe<Scalars['numeric']>
  _in?: Maybe<Array<Scalars['numeric']>>
  _isNull?: Maybe<Scalars['Boolean']>
  _lt?: Maybe<Scalars['numeric']>
  _lte?: Maybe<Scalars['numeric']>
  _neq?: Maybe<Scalars['numeric']>
  _nin?: Maybe<Array<Scalars['numeric']>>
}

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  Asc = 'ASC',
  /** in ascending order, nulls first */
  AscNullsFirst = 'ASC_NULLS_FIRST',
  /** in ascending order, nulls last */
  AscNullsLast = 'ASC_NULLS_LAST',
  /** in descending order, nulls first */
  Desc = 'DESC',
  /** in descending order, nulls first */
  DescNullsFirst = 'DESC_NULLS_FIRST',
  /** in descending order, nulls last */
  DescNullsLast = 'DESC_NULLS_LAST',
}

/** columns and relationships of "primary_receipt" */
export type PrimaryReceipt = {
  __typename?: 'PrimaryReceipt'
  buyer: Scalars['String']
  createdAt: Scalars['timestamptz']
  createdAtOnChain: Scalars['bigint']
  id: Scalars['String']
  mint: Scalars['String']
  modifiedAt: Scalars['timestamptz']
  price: Scalars['bigint']
  slot: Scalars['bigint']
  tokenSize: Scalars['bigint']
  writeVersion: Scalars['bigint']
}

/** aggregated selection of "primary_receipt" */
export type PrimaryReceiptAggregate = {
  __typename?: 'PrimaryReceiptAggregate'
  aggregate?: Maybe<PrimaryReceiptAggregateFields>
  nodes: Array<PrimaryReceipt>
}

/** aggregate fields of "primary_receipt" */
export type PrimaryReceiptAggregateFields = {
  __typename?: 'PrimaryReceiptAggregateFields'
  avg?: Maybe<PrimaryReceiptAvgFields>
  count: Scalars['Int']
  max?: Maybe<PrimaryReceiptMaxFields>
  min?: Maybe<PrimaryReceiptMinFields>
  stddev?: Maybe<PrimaryReceiptStddevFields>
  stddevPop?: Maybe<PrimaryReceiptStddev_PopFields>
  stddevSamp?: Maybe<PrimaryReceiptStddev_SampFields>
  sum?: Maybe<PrimaryReceiptSumFields>
  varPop?: Maybe<PrimaryReceiptVar_PopFields>
  varSamp?: Maybe<PrimaryReceiptVar_SampFields>
  variance?: Maybe<PrimaryReceiptVarianceFields>
}

/** aggregate fields of "primary_receipt" */
export type PrimaryReceiptAggregateFieldsCountArgs = {
  columns?: Maybe<Array<PrimaryReceiptSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** order by aggregate values of table "primary_receipt" */
export type PrimaryReceiptAggregateOrderBy = {
  avg?: Maybe<Primary_Receipt_Avg_Order_By>
  count?: Maybe<OrderBy>
  max?: Maybe<Primary_Receipt_Max_Order_By>
  min?: Maybe<Primary_Receipt_Min_Order_By>
  stddev?: Maybe<Primary_Receipt_Stddev_Order_By>
  stddev_pop?: Maybe<Primary_Receipt_Stddev_Pop_Order_By>
  stddev_samp?: Maybe<Primary_Receipt_Stddev_Samp_Order_By>
  sum?: Maybe<Primary_Receipt_Sum_Order_By>
  var_pop?: Maybe<Primary_Receipt_Var_Pop_Order_By>
  var_samp?: Maybe<Primary_Receipt_Var_Samp_Order_By>
  variance?: Maybe<Primary_Receipt_Variance_Order_By>
}

/** aggregate avg on columns */
export type PrimaryReceiptAvgFields = {
  __typename?: 'PrimaryReceiptAvgFields'
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Boolean expression to filter rows from the table "primary_receipt". All fields are combined with a logical 'AND'. */
export type PrimaryReceiptBoolExp = {
  _and?: Maybe<Array<PrimaryReceiptBoolExp>>
  _not?: Maybe<PrimaryReceiptBoolExp>
  _or?: Maybe<Array<PrimaryReceiptBoolExp>>
  buyer?: Maybe<StringComparisonExp>
  createdAt?: Maybe<TimestamptzComparisonExp>
  createdAtOnChain?: Maybe<BigintComparisonExp>
  id?: Maybe<StringComparisonExp>
  mint?: Maybe<StringComparisonExp>
  modifiedAt?: Maybe<TimestamptzComparisonExp>
  price?: Maybe<BigintComparisonExp>
  slot?: Maybe<BigintComparisonExp>
  tokenSize?: Maybe<BigintComparisonExp>
  writeVersion?: Maybe<BigintComparisonExp>
}

/** aggregate max on columns */
export type PrimaryReceiptMaxFields = {
  __typename?: 'PrimaryReceiptMaxFields'
  buyer?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate min on columns */
export type PrimaryReceiptMinFields = {
  __typename?: 'PrimaryReceiptMinFields'
  buyer?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** Ordering options when selecting data from "primary_receipt". */
export type PrimaryReceiptOrderBy = {
  buyer?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** select columns of table "primary_receipt" */
export enum PrimaryReceiptSelectColumn {
  /** column name */
  Buyer = 'buyer',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedAtOnChain = 'createdAtOnChain',
  /** column name */
  Id = 'id',
  /** column name */
  Mint = 'mint',
  /** column name */
  ModifiedAt = 'modifiedAt',
  /** column name */
  Price = 'price',
  /** column name */
  Slot = 'slot',
  /** column name */
  TokenSize = 'tokenSize',
  /** column name */
  WriteVersion = 'writeVersion',
}

/** aggregate stddev on columns */
export type PrimaryReceiptStddevFields = {
  __typename?: 'PrimaryReceiptStddevFields'
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_pop on columns */
export type PrimaryReceiptStddev_PopFields = {
  __typename?: 'PrimaryReceiptStddev_popFields'
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_samp on columns */
export type PrimaryReceiptStddev_SampFields = {
  __typename?: 'PrimaryReceiptStddev_sampFields'
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Streaming cursor of the table "primary_receipt" */
export type PrimaryReceiptStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PrimaryReceiptStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type PrimaryReceiptStreamCursorValueInput = {
  buyer?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate sum on columns */
export type PrimaryReceiptSumFields = {
  __typename?: 'PrimaryReceiptSumFields'
  createdAtOnChain?: Maybe<Scalars['bigint']>
  price?: Maybe<Scalars['bigint']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate var_pop on columns */
export type PrimaryReceiptVar_PopFields = {
  __typename?: 'PrimaryReceiptVar_popFields'
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate var_samp on columns */
export type PrimaryReceiptVar_SampFields = {
  __typename?: 'PrimaryReceiptVar_sampFields'
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate variance on columns */
export type PrimaryReceiptVarianceFields = {
  __typename?: 'PrimaryReceiptVarianceFields'
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** columns and relationships of "purchase_receipt" */
export type PurchaseReceipt = {
  __typename?: 'PurchaseReceipt'
  auctionHouse: Scalars['String']
  bookkeeper: Scalars['String']
  bump: Scalars['Int']
  buyer: Scalars['String']
  createdAt: Scalars['timestamptz']
  createdAtOnChain: Scalars['bigint']
  id: Scalars['String']
  metadata: Scalars['String']
  /** An object relationship */
  metadataObject?: Maybe<Metadata>
  modifiedAt: Scalars['timestamptz']
  price: Scalars['bigint']
  seller: Scalars['String']
  slot: Scalars['bigint']
  tokenSize: Scalars['bigint']
  writeVersion: Scalars['bigint']
}

/** aggregated selection of "purchase_receipt" */
export type PurchaseReceiptAggregate = {
  __typename?: 'PurchaseReceiptAggregate'
  aggregate?: Maybe<PurchaseReceiptAggregateFields>
  nodes: Array<PurchaseReceipt>
}

/** aggregate fields of "purchase_receipt" */
export type PurchaseReceiptAggregateFields = {
  __typename?: 'PurchaseReceiptAggregateFields'
  avg?: Maybe<PurchaseReceiptAvgFields>
  count: Scalars['Int']
  max?: Maybe<PurchaseReceiptMaxFields>
  min?: Maybe<PurchaseReceiptMinFields>
  stddev?: Maybe<PurchaseReceiptStddevFields>
  stddevPop?: Maybe<PurchaseReceiptStddev_PopFields>
  stddevSamp?: Maybe<PurchaseReceiptStddev_SampFields>
  sum?: Maybe<PurchaseReceiptSumFields>
  varPop?: Maybe<PurchaseReceiptVar_PopFields>
  varSamp?: Maybe<PurchaseReceiptVar_SampFields>
  variance?: Maybe<PurchaseReceiptVarianceFields>
}

/** aggregate fields of "purchase_receipt" */
export type PurchaseReceiptAggregateFieldsCountArgs = {
  columns?: Maybe<Array<PurchaseReceiptSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** order by aggregate values of table "purchase_receipt" */
export type PurchaseReceiptAggregateOrderBy = {
  avg?: Maybe<Purchase_Receipt_Avg_Order_By>
  count?: Maybe<OrderBy>
  max?: Maybe<Purchase_Receipt_Max_Order_By>
  min?: Maybe<Purchase_Receipt_Min_Order_By>
  stddev?: Maybe<Purchase_Receipt_Stddev_Order_By>
  stddev_pop?: Maybe<Purchase_Receipt_Stddev_Pop_Order_By>
  stddev_samp?: Maybe<Purchase_Receipt_Stddev_Samp_Order_By>
  sum?: Maybe<Purchase_Receipt_Sum_Order_By>
  var_pop?: Maybe<Purchase_Receipt_Var_Pop_Order_By>
  var_samp?: Maybe<Purchase_Receipt_Var_Samp_Order_By>
  variance?: Maybe<Purchase_Receipt_Variance_Order_By>
}

/** aggregate avg on columns */
export type PurchaseReceiptAvgFields = {
  __typename?: 'PurchaseReceiptAvgFields'
  bump?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Boolean expression to filter rows from the table "purchase_receipt". All fields are combined with a logical 'AND'. */
export type PurchaseReceiptBoolExp = {
  _and?: Maybe<Array<PurchaseReceiptBoolExp>>
  _not?: Maybe<PurchaseReceiptBoolExp>
  _or?: Maybe<Array<PurchaseReceiptBoolExp>>
  auctionHouse?: Maybe<StringComparisonExp>
  bookkeeper?: Maybe<StringComparisonExp>
  bump?: Maybe<IntComparisonExp>
  buyer?: Maybe<StringComparisonExp>
  createdAt?: Maybe<TimestamptzComparisonExp>
  createdAtOnChain?: Maybe<BigintComparisonExp>
  id?: Maybe<StringComparisonExp>
  metadata?: Maybe<StringComparisonExp>
  metadataObject?: Maybe<MetadataBoolExp>
  modifiedAt?: Maybe<TimestamptzComparisonExp>
  price?: Maybe<BigintComparisonExp>
  seller?: Maybe<StringComparisonExp>
  slot?: Maybe<BigintComparisonExp>
  tokenSize?: Maybe<BigintComparisonExp>
  writeVersion?: Maybe<BigintComparisonExp>
}

/** aggregate max on columns */
export type PurchaseReceiptMaxFields = {
  __typename?: 'PurchaseReceiptMaxFields'
  auctionHouse?: Maybe<Scalars['String']>
  bookkeeper?: Maybe<Scalars['String']>
  bump?: Maybe<Scalars['Int']>
  buyer?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  seller?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate min on columns */
export type PurchaseReceiptMinFields = {
  __typename?: 'PurchaseReceiptMinFields'
  auctionHouse?: Maybe<Scalars['String']>
  bookkeeper?: Maybe<Scalars['String']>
  bump?: Maybe<Scalars['Int']>
  buyer?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  seller?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** Ordering options when selecting data from "purchase_receipt". */
export type PurchaseReceiptOrderBy = {
  auctionHouse?: Maybe<OrderBy>
  bookkeeper?: Maybe<OrderBy>
  bump?: Maybe<OrderBy>
  buyer?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  metadataObject?: Maybe<MetadataOrderBy>
  modifiedAt?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  seller?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** select columns of table "purchase_receipt" */
export enum PurchaseReceiptSelectColumn {
  /** column name */
  AuctionHouse = 'auctionHouse',
  /** column name */
  Bookkeeper = 'bookkeeper',
  /** column name */
  Bump = 'bump',
  /** column name */
  Buyer = 'buyer',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedAtOnChain = 'createdAtOnChain',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ModifiedAt = 'modifiedAt',
  /** column name */
  Price = 'price',
  /** column name */
  Seller = 'seller',
  /** column name */
  Slot = 'slot',
  /** column name */
  TokenSize = 'tokenSize',
  /** column name */
  WriteVersion = 'writeVersion',
}

/** aggregate stddev on columns */
export type PurchaseReceiptStddevFields = {
  __typename?: 'PurchaseReceiptStddevFields'
  bump?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_pop on columns */
export type PurchaseReceiptStddev_PopFields = {
  __typename?: 'PurchaseReceiptStddev_popFields'
  bump?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_samp on columns */
export type PurchaseReceiptStddev_SampFields = {
  __typename?: 'PurchaseReceiptStddev_sampFields'
  bump?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Streaming cursor of the table "purchase_receipt" */
export type PurchaseReceiptStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PurchaseReceiptStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type PurchaseReceiptStreamCursorValueInput = {
  auctionHouse?: Maybe<Scalars['String']>
  bookkeeper?: Maybe<Scalars['String']>
  bump?: Maybe<Scalars['Int']>
  buyer?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  price?: Maybe<Scalars['bigint']>
  seller?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate sum on columns */
export type PurchaseReceiptSumFields = {
  __typename?: 'PurchaseReceiptSumFields'
  bump?: Maybe<Scalars['Int']>
  createdAtOnChain?: Maybe<Scalars['bigint']>
  price?: Maybe<Scalars['bigint']>
  slot?: Maybe<Scalars['bigint']>
  tokenSize?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate var_pop on columns */
export type PurchaseReceiptVar_PopFields = {
  __typename?: 'PurchaseReceiptVar_popFields'
  bump?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate var_samp on columns */
export type PurchaseReceiptVar_SampFields = {
  __typename?: 'PurchaseReceiptVar_sampFields'
  bump?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate variance on columns */
export type PurchaseReceiptVarianceFields = {
  __typename?: 'PurchaseReceiptVarianceFields'
  bump?: Maybe<Scalars['Float']>
  createdAtOnChain?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  tokenSize?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** columns and relationships of "receipt" */
export type Receipt = {
  __typename?: 'Receipt'
  buyer?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  id?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  price?: Maybe<Scalars['bigint']>
  receiptType?: Maybe<Scalars['String']>
  seller?: Maybe<Scalars['String']>
  tokenSize?: Maybe<Scalars['bigint']>
}

/** Boolean expression to filter rows from the table "receipt". All fields are combined with a logical 'AND'. */
export type ReceiptBoolExp = {
  _and?: Maybe<Array<ReceiptBoolExp>>
  _not?: Maybe<ReceiptBoolExp>
  _or?: Maybe<Array<ReceiptBoolExp>>
  buyer?: Maybe<StringComparisonExp>
  createdAt?: Maybe<TimestamptzComparisonExp>
  id?: Maybe<StringComparisonExp>
  mint?: Maybe<StringComparisonExp>
  price?: Maybe<BigintComparisonExp>
  receiptType?: Maybe<StringComparisonExp>
  seller?: Maybe<StringComparisonExp>
  tokenSize?: Maybe<BigintComparisonExp>
}

/** Ordering options when selecting data from "receipt". */
export type ReceiptOrderBy = {
  buyer?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  receiptType?: Maybe<OrderBy>
  seller?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
}

/** select columns of table "receipt" */
export enum ReceiptSelectColumn {
  /** column name */
  Buyer = 'buyer',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Mint = 'mint',
  /** column name */
  Price = 'price',
  /** column name */
  ReceiptType = 'receiptType',
  /** column name */
  Seller = 'seller',
  /** column name */
  TokenSize = 'tokenSize',
}

/** Streaming cursor of the table "receipt" */
export type ReceiptStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ReceiptStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type ReceiptStreamCursorValueInput = {
  buyer?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  id?: Maybe<Scalars['String']>
  mint?: Maybe<Scalars['String']>
  price?: Maybe<Scalars['bigint']>
  receiptType?: Maybe<Scalars['String']>
  seller?: Maybe<Scalars['String']>
  tokenSize?: Maybe<Scalars['bigint']>
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: Maybe<Scalars['String']>
  _gt?: Maybe<Scalars['String']>
  _gte?: Maybe<Scalars['String']>
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>
  _in?: Maybe<Array<Scalars['String']>>
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>
  _isNull?: Maybe<Scalars['Boolean']>
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>
  _lt?: Maybe<Scalars['String']>
  _lte?: Maybe<Scalars['String']>
  _neq?: Maybe<Scalars['String']>
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>
  _nin?: Maybe<Array<Scalars['String']>>
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>
}

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: Maybe<Scalars['timestamptz']>
  _gt?: Maybe<Scalars['timestamptz']>
  _gte?: Maybe<Scalars['timestamptz']>
  _in?: Maybe<Array<Scalars['timestamptz']>>
  _isNull?: Maybe<Scalars['Boolean']>
  _lt?: Maybe<Scalars['timestamptz']>
  _lte?: Maybe<Scalars['timestamptz']>
  _neq?: Maybe<Scalars['timestamptz']>
  _nin?: Maybe<Array<Scalars['timestamptz']>>
}

/** columns and relationships of "token_account" */
export type TokenAccount = {
  __typename?: 'TokenAccount'
  amount: Scalars['bigint']
  closeAuthority?: Maybe<Scalars['String']>
  createdAt: Scalars['timestamptz']
  delegate?: Maybe<Scalars['String']>
  delegatedAmount?: Maybe<Scalars['bigint']>
  id: Scalars['String']
  isNative?: Maybe<Scalars['bigint']>
  mint: Scalars['String']
  /** An object relationship */
  mintObject?: Maybe<Mint>
  modifiedAt: Scalars['timestamptz']
  owner: Scalars['String']
  slot: Scalars['bigint']
  state: Scalars['String']
  /** An array relationship */
  tokenAccounts: Array<TokenAccount>
  /** An aggregate relationship */
  tokenAccountsAggregate: TokenAccountAggregate
  writeVersion: Scalars['bigint']
}

/** columns and relationships of "token_account" */
export type TokenAccountTokenAccountsArgs = {
  distinctOn?: Maybe<Array<TokenAccountSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<TokenAccountOrderBy>>
  where?: Maybe<TokenAccountBoolExp>
}

/** columns and relationships of "token_account" */
export type TokenAccountTokenAccountsAggregateArgs = {
  distinctOn?: Maybe<Array<TokenAccountSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<TokenAccountOrderBy>>
  where?: Maybe<TokenAccountBoolExp>
}

/** aggregated selection of "token_account" */
export type TokenAccountAggregate = {
  __typename?: 'TokenAccountAggregate'
  aggregate?: Maybe<TokenAccountAggregateFields>
  nodes: Array<TokenAccount>
}

/** aggregate fields of "token_account" */
export type TokenAccountAggregateFields = {
  __typename?: 'TokenAccountAggregateFields'
  avg?: Maybe<TokenAccountAvgFields>
  count: Scalars['Int']
  max?: Maybe<TokenAccountMaxFields>
  min?: Maybe<TokenAccountMinFields>
  stddev?: Maybe<TokenAccountStddevFields>
  stddevPop?: Maybe<TokenAccountStddev_PopFields>
  stddevSamp?: Maybe<TokenAccountStddev_SampFields>
  sum?: Maybe<TokenAccountSumFields>
  varPop?: Maybe<TokenAccountVar_PopFields>
  varSamp?: Maybe<TokenAccountVar_SampFields>
  variance?: Maybe<TokenAccountVarianceFields>
}

/** aggregate fields of "token_account" */
export type TokenAccountAggregateFieldsCountArgs = {
  columns?: Maybe<Array<TokenAccountSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
}

/** order by aggregate values of table "token_account" */
export type TokenAccountAggregateOrderBy = {
  avg?: Maybe<Token_Account_Avg_Order_By>
  count?: Maybe<OrderBy>
  max?: Maybe<Token_Account_Max_Order_By>
  min?: Maybe<Token_Account_Min_Order_By>
  stddev?: Maybe<Token_Account_Stddev_Order_By>
  stddev_pop?: Maybe<Token_Account_Stddev_Pop_Order_By>
  stddev_samp?: Maybe<Token_Account_Stddev_Samp_Order_By>
  sum?: Maybe<Token_Account_Sum_Order_By>
  var_pop?: Maybe<Token_Account_Var_Pop_Order_By>
  var_samp?: Maybe<Token_Account_Var_Samp_Order_By>
  variance?: Maybe<Token_Account_Variance_Order_By>
}

/** aggregate avg on columns */
export type TokenAccountAvgFields = {
  __typename?: 'TokenAccountAvgFields'
  amount?: Maybe<Scalars['Float']>
  delegatedAmount?: Maybe<Scalars['Float']>
  isNative?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Boolean expression to filter rows from the table "token_account". All fields are combined with a logical 'AND'. */
export type TokenAccountBoolExp = {
  _and?: Maybe<Array<TokenAccountBoolExp>>
  _not?: Maybe<TokenAccountBoolExp>
  _or?: Maybe<Array<TokenAccountBoolExp>>
  amount?: Maybe<BigintComparisonExp>
  closeAuthority?: Maybe<StringComparisonExp>
  createdAt?: Maybe<TimestamptzComparisonExp>
  delegate?: Maybe<StringComparisonExp>
  delegatedAmount?: Maybe<BigintComparisonExp>
  id?: Maybe<StringComparisonExp>
  isNative?: Maybe<BigintComparisonExp>
  mint?: Maybe<StringComparisonExp>
  mintObject?: Maybe<MintBoolExp>
  modifiedAt?: Maybe<TimestamptzComparisonExp>
  owner?: Maybe<StringComparisonExp>
  slot?: Maybe<BigintComparisonExp>
  state?: Maybe<StringComparisonExp>
  tokenAccounts?: Maybe<TokenAccountBoolExp>
  tokenAccounts_aggregate?: Maybe<Token_Account_Aggregate_Bool_Exp>
  writeVersion?: Maybe<BigintComparisonExp>
}

/** aggregate max on columns */
export type TokenAccountMaxFields = {
  __typename?: 'TokenAccountMaxFields'
  amount?: Maybe<Scalars['bigint']>
  closeAuthority?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  delegate?: Maybe<Scalars['String']>
  delegatedAmount?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  isNative?: Maybe<Scalars['bigint']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  owner?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  state?: Maybe<Scalars['String']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate min on columns */
export type TokenAccountMinFields = {
  __typename?: 'TokenAccountMinFields'
  amount?: Maybe<Scalars['bigint']>
  closeAuthority?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  delegate?: Maybe<Scalars['String']>
  delegatedAmount?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  isNative?: Maybe<Scalars['bigint']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  owner?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  state?: Maybe<Scalars['String']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** Ordering options when selecting data from "token_account". */
export type TokenAccountOrderBy = {
  amount?: Maybe<OrderBy>
  closeAuthority?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  delegate?: Maybe<OrderBy>
  delegatedAmount?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  isNative?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  mintObject?: Maybe<MintOrderBy>
  modifiedAt?: Maybe<OrderBy>
  owner?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  state?: Maybe<OrderBy>
  tokenAccountsAggregate?: Maybe<TokenAccountAggregateOrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** select columns of table "token_account" */
export enum TokenAccountSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CloseAuthority = 'closeAuthority',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Delegate = 'delegate',
  /** column name */
  DelegatedAmount = 'delegatedAmount',
  /** column name */
  Id = 'id',
  /** column name */
  IsNative = 'isNative',
  /** column name */
  Mint = 'mint',
  /** column name */
  ModifiedAt = 'modifiedAt',
  /** column name */
  Owner = 'owner',
  /** column name */
  Slot = 'slot',
  /** column name */
  State = 'state',
  /** column name */
  WriteVersion = 'writeVersion',
}

/** aggregate stddev on columns */
export type TokenAccountStddevFields = {
  __typename?: 'TokenAccountStddevFields'
  amount?: Maybe<Scalars['Float']>
  delegatedAmount?: Maybe<Scalars['Float']>
  isNative?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_pop on columns */
export type TokenAccountStddev_PopFields = {
  __typename?: 'TokenAccountStddev_popFields'
  amount?: Maybe<Scalars['Float']>
  delegatedAmount?: Maybe<Scalars['Float']>
  isNative?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate stddev_samp on columns */
export type TokenAccountStddev_SampFields = {
  __typename?: 'TokenAccountStddev_sampFields'
  amount?: Maybe<Scalars['Float']>
  delegatedAmount?: Maybe<Scalars['Float']>
  isNative?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** Streaming cursor of the table "token_account" */
export type TokenAccountStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TokenAccountStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type TokenAccountStreamCursorValueInput = {
  amount?: Maybe<Scalars['bigint']>
  closeAuthority?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['timestamptz']>
  delegate?: Maybe<Scalars['String']>
  delegatedAmount?: Maybe<Scalars['bigint']>
  id?: Maybe<Scalars['String']>
  isNative?: Maybe<Scalars['bigint']>
  mint?: Maybe<Scalars['String']>
  modifiedAt?: Maybe<Scalars['timestamptz']>
  owner?: Maybe<Scalars['String']>
  slot?: Maybe<Scalars['bigint']>
  state?: Maybe<Scalars['String']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate sum on columns */
export type TokenAccountSumFields = {
  __typename?: 'TokenAccountSumFields'
  amount?: Maybe<Scalars['bigint']>
  delegatedAmount?: Maybe<Scalars['bigint']>
  isNative?: Maybe<Scalars['bigint']>
  slot?: Maybe<Scalars['bigint']>
  writeVersion?: Maybe<Scalars['bigint']>
}

/** aggregate var_pop on columns */
export type TokenAccountVar_PopFields = {
  __typename?: 'TokenAccountVar_popFields'
  amount?: Maybe<Scalars['Float']>
  delegatedAmount?: Maybe<Scalars['Float']>
  isNative?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate var_samp on columns */
export type TokenAccountVar_SampFields = {
  __typename?: 'TokenAccountVar_sampFields'
  amount?: Maybe<Scalars['Float']>
  delegatedAmount?: Maybe<Scalars['Float']>
  isNative?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** aggregate variance on columns */
export type TokenAccountVarianceFields = {
  __typename?: 'TokenAccountVarianceFields'
  amount?: Maybe<Scalars['Float']>
  delegatedAmount?: Maybe<Scalars['Float']>
  isNative?: Maybe<Scalars['Float']>
  slot?: Maybe<Scalars['Float']>
  writeVersion?: Maybe<Scalars['Float']>
}

/** columns and relationships of "video_leaderboard" */
export type VideoLeaderboard = {
  __typename?: 'VideoLeaderboard'
  allPrim?: Maybe<Scalars['numeric']>
  allSec?: Maybe<Scalars['numeric']>
  allTime?: Maybe<Scalars['numeric']>
  /** An object relationship */
  floorPriceObject?: Maybe<FloorPrice>
  mint?: Maybe<Scalars['String']>
  /** An object relationship */
  mintObject?: Maybe<Mint>
  oneDay?: Maybe<Scalars['numeric']>
  oneDayPrim?: Maybe<Scalars['numeric']>
  oneDaySec?: Maybe<Scalars['numeric']>
  oneHour?: Maybe<Scalars['numeric']>
  oneHourPrim?: Maybe<Scalars['numeric']>
  oneHourSec?: Maybe<Scalars['numeric']>
  sevenDayPrim?: Maybe<Scalars['numeric']>
  sevenDaySec?: Maybe<Scalars['numeric']>
  sevenDays?: Maybe<Scalars['numeric']>
  sixHourPrim?: Maybe<Scalars['numeric']>
  sixHourSec?: Maybe<Scalars['numeric']>
  sixHours?: Maybe<Scalars['numeric']>
  thirtyDayPrim?: Maybe<Scalars['numeric']>
  thirtyDaySec?: Maybe<Scalars['numeric']>
  thirtyDays?: Maybe<Scalars['numeric']>
}

/** Boolean expression to filter rows from the table "video_leaderboard". All fields are combined with a logical 'AND'. */
export type VideoLeaderboardBoolExp = {
  _and?: Maybe<Array<VideoLeaderboardBoolExp>>
  _not?: Maybe<VideoLeaderboardBoolExp>
  _or?: Maybe<Array<VideoLeaderboardBoolExp>>
  allPrim?: Maybe<NumericComparisonExp>
  allSec?: Maybe<NumericComparisonExp>
  allTime?: Maybe<NumericComparisonExp>
  floorPriceObject?: Maybe<FloorPriceBoolExp>
  mint?: Maybe<StringComparisonExp>
  mintObject?: Maybe<MintBoolExp>
  oneDay?: Maybe<NumericComparisonExp>
  oneDayPrim?: Maybe<NumericComparisonExp>
  oneDaySec?: Maybe<NumericComparisonExp>
  oneHour?: Maybe<NumericComparisonExp>
  oneHourPrim?: Maybe<NumericComparisonExp>
  oneHourSec?: Maybe<NumericComparisonExp>
  sevenDayPrim?: Maybe<NumericComparisonExp>
  sevenDaySec?: Maybe<NumericComparisonExp>
  sevenDays?: Maybe<NumericComparisonExp>
  sixHourPrim?: Maybe<NumericComparisonExp>
  sixHourSec?: Maybe<NumericComparisonExp>
  sixHours?: Maybe<NumericComparisonExp>
  thirtyDayPrim?: Maybe<NumericComparisonExp>
  thirtyDaySec?: Maybe<NumericComparisonExp>
  thirtyDays?: Maybe<NumericComparisonExp>
}

/** Ordering options when selecting data from "video_leaderboard". */
export type VideoLeaderboardOrderBy = {
  allPrim?: Maybe<OrderBy>
  allSec?: Maybe<OrderBy>
  allTime?: Maybe<OrderBy>
  floorPriceObject?: Maybe<FloorPriceOrderBy>
  mint?: Maybe<OrderBy>
  mintObject?: Maybe<MintOrderBy>
  oneDay?: Maybe<OrderBy>
  oneDayPrim?: Maybe<OrderBy>
  oneDaySec?: Maybe<OrderBy>
  oneHour?: Maybe<OrderBy>
  oneHourPrim?: Maybe<OrderBy>
  oneHourSec?: Maybe<OrderBy>
  sevenDayPrim?: Maybe<OrderBy>
  sevenDaySec?: Maybe<OrderBy>
  sevenDays?: Maybe<OrderBy>
  sixHourPrim?: Maybe<OrderBy>
  sixHourSec?: Maybe<OrderBy>
  sixHours?: Maybe<OrderBy>
  thirtyDayPrim?: Maybe<OrderBy>
  thirtyDaySec?: Maybe<OrderBy>
  thirtyDays?: Maybe<OrderBy>
}

/** select columns of table "video_leaderboard" */
export enum VideoLeaderboardSelectColumn {
  /** column name */
  AllPrim = 'allPrim',
  /** column name */
  AllSec = 'allSec',
  /** column name */
  AllTime = 'allTime',
  /** column name */
  Mint = 'mint',
  /** column name */
  OneDay = 'oneDay',
  /** column name */
  OneDayPrim = 'oneDayPrim',
  /** column name */
  OneDaySec = 'oneDaySec',
  /** column name */
  OneHour = 'oneHour',
  /** column name */
  OneHourPrim = 'oneHourPrim',
  /** column name */
  OneHourSec = 'oneHourSec',
  /** column name */
  SevenDayPrim = 'sevenDayPrim',
  /** column name */
  SevenDaySec = 'sevenDaySec',
  /** column name */
  SevenDays = 'sevenDays',
  /** column name */
  SixHourPrim = 'sixHourPrim',
  /** column name */
  SixHourSec = 'sixHourSec',
  /** column name */
  SixHours = 'sixHours',
  /** column name */
  ThirtyDayPrim = 'thirtyDayPrim',
  /** column name */
  ThirtyDaySec = 'thirtyDaySec',
  /** column name */
  ThirtyDays = 'thirtyDays',
}

/** Streaming cursor of the table "video_leaderboard" */
export type VideoLeaderboardStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VideoLeaderboardStreamCursorValueInput
  /** cursor ordering */
  ordering?: Maybe<CursorOrdering>
}

/** Initial value of the column from where the streaming should start */
export type VideoLeaderboardStreamCursorValueInput = {
  allPrim?: Maybe<Scalars['numeric']>
  allSec?: Maybe<Scalars['numeric']>
  allTime?: Maybe<Scalars['numeric']>
  mint?: Maybe<Scalars['String']>
  oneDay?: Maybe<Scalars['numeric']>
  oneDayPrim?: Maybe<Scalars['numeric']>
  oneDaySec?: Maybe<Scalars['numeric']>
  oneHour?: Maybe<Scalars['numeric']>
  oneHourPrim?: Maybe<Scalars['numeric']>
  oneHourSec?: Maybe<Scalars['numeric']>
  sevenDayPrim?: Maybe<Scalars['numeric']>
  sevenDaySec?: Maybe<Scalars['numeric']>
  sevenDays?: Maybe<Scalars['numeric']>
  sixHourPrim?: Maybe<Scalars['numeric']>
  sixHourSec?: Maybe<Scalars['numeric']>
  sixHours?: Maybe<Scalars['numeric']>
  thirtyDayPrim?: Maybe<Scalars['numeric']>
  thirtyDaySec?: Maybe<Scalars['numeric']>
  thirtyDays?: Maybe<Scalars['numeric']>
}

export type Bid_Receipt_Aggregate_Bool_Exp = {
  count?: Maybe<Bid_Receipt_Aggregate_Bool_Exp_Count>
}

export type Bid_Receipt_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<BidReceiptSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
  filter?: Maybe<BidReceiptBoolExp>
  predicate: IntComparisonExp
}

/** order by avg() on columns of table "bid_receipt" */
export type Bid_Receipt_Avg_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by max() on columns of table "bid_receipt" */
export type Bid_Receipt_Max_Order_By = {
  auctionHouse?: Maybe<OrderBy>
  bookkeeper?: Maybe<OrderBy>
  bump?: Maybe<OrderBy>
  buyer?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  purchaseReceipt?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenAccount?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeState?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by min() on columns of table "bid_receipt" */
export type Bid_Receipt_Min_Order_By = {
  auctionHouse?: Maybe<OrderBy>
  bookkeeper?: Maybe<OrderBy>
  bump?: Maybe<OrderBy>
  buyer?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  purchaseReceipt?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenAccount?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeState?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev() on columns of table "bid_receipt" */
export type Bid_Receipt_Stddev_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev_pop() on columns of table "bid_receipt" */
export type Bid_Receipt_Stddev_Pop_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev_samp() on columns of table "bid_receipt" */
export type Bid_Receipt_Stddev_Samp_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by sum() on columns of table "bid_receipt" */
export type Bid_Receipt_Sum_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by var_pop() on columns of table "bid_receipt" */
export type Bid_Receipt_Var_Pop_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by var_samp() on columns of table "bid_receipt" */
export type Bid_Receipt_Var_Samp_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by variance() on columns of table "bid_receipt" */
export type Bid_Receipt_Variance_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

export type Creator_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Creator_Aggregate_Bool_Exp_Bool_And>
  bool_or?: Maybe<Creator_Aggregate_Bool_Exp_Bool_Or>
  count?: Maybe<Creator_Aggregate_Bool_Exp_Count>
}

export type Creator_Aggregate_Bool_Exp_Bool_And = {
  arguments: Creator_Select_Column_Creator_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: Maybe<Scalars['Boolean']>
  filter?: Maybe<CreatorBoolExp>
  predicate: BooleanComparisonExp
}

export type Creator_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Creator_Select_Column_Creator_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: Maybe<Scalars['Boolean']>
  filter?: Maybe<CreatorBoolExp>
  predicate: BooleanComparisonExp
}

export type Creator_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<CreatorSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
  filter?: Maybe<CreatorBoolExp>
  predicate: IntComparisonExp
}

/** order by avg() on columns of table "creator" */
export type Creator_Avg_Order_By = {
  share?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by max() on columns of table "creator" */
export type Creator_Max_Order_By = {
  address?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  share?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by min() on columns of table "creator" */
export type Creator_Min_Order_By = {
  address?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  share?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** select "creator_aggregate_bool_exp_bool_and_arguments_columns" columns of table "creator" */
export enum Creator_Select_Column_Creator_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Verified = 'verified',
}

/** select "creator_aggregate_bool_exp_bool_or_arguments_columns" columns of table "creator" */
export enum Creator_Select_Column_Creator_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Verified = 'verified',
}

/** order by stddev() on columns of table "creator" */
export type Creator_Stddev_Order_By = {
  share?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev_pop() on columns of table "creator" */
export type Creator_Stddev_Pop_Order_By = {
  share?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev_samp() on columns of table "creator" */
export type Creator_Stddev_Samp_Order_By = {
  share?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by sum() on columns of table "creator" */
export type Creator_Sum_Order_By = {
  share?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by var_pop() on columns of table "creator" */
export type Creator_Var_Pop_Order_By = {
  share?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by var_samp() on columns of table "creator" */
export type Creator_Var_Samp_Order_By = {
  share?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by variance() on columns of table "creator" */
export type Creator_Variance_Order_By = {
  share?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

export type Listing_Receipt_Aggregate_Bool_Exp = {
  count?: Maybe<Listing_Receipt_Aggregate_Bool_Exp_Count>
}

export type Listing_Receipt_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ListingReceiptSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
  filter?: Maybe<ListingReceiptBoolExp>
  predicate: IntComparisonExp
}

/** order by avg() on columns of table "listing_receipt" */
export type Listing_Receipt_Avg_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by max() on columns of table "listing_receipt" */
export type Listing_Receipt_Max_Order_By = {
  auctionHouse?: Maybe<OrderBy>
  bookkeeper?: Maybe<OrderBy>
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  purchaseReceipt?: Maybe<OrderBy>
  seller?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeState?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by min() on columns of table "listing_receipt" */
export type Listing_Receipt_Min_Order_By = {
  auctionHouse?: Maybe<OrderBy>
  bookkeeper?: Maybe<OrderBy>
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  purchaseReceipt?: Maybe<OrderBy>
  seller?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeState?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev() on columns of table "listing_receipt" */
export type Listing_Receipt_Stddev_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev_pop() on columns of table "listing_receipt" */
export type Listing_Receipt_Stddev_Pop_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev_samp() on columns of table "listing_receipt" */
export type Listing_Receipt_Stddev_Samp_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by sum() on columns of table "listing_receipt" */
export type Listing_Receipt_Sum_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by var_pop() on columns of table "listing_receipt" */
export type Listing_Receipt_Var_Pop_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by var_samp() on columns of table "listing_receipt" */
export type Listing_Receipt_Var_Samp_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by variance() on columns of table "listing_receipt" */
export type Listing_Receipt_Variance_Order_By = {
  bump?: Maybe<OrderBy>
  canceledAtOnChain?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  tradeStateBump?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

export type Listing_With_Token_Aggregate_Bool_Exp = {
  count?: Maybe<Listing_With_Token_Aggregate_Bool_Exp_Count>
}

export type Listing_With_Token_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ListingWithTokenSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
  filter?: Maybe<ListingWithTokenBoolExp>
  predicate: IntComparisonExp
}

/** order by avg() on columns of table "listing_with_token" */
export type Listing_With_Token_Avg_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
}

/** order by max() on columns of table "listing_with_token" */
export type Listing_With_Token_Max_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  seller?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenAccount?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
}

/** order by min() on columns of table "listing_with_token" */
export type Listing_With_Token_Min_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  seller?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenAccount?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
}

/** order by stddev() on columns of table "listing_with_token" */
export type Listing_With_Token_Stddev_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
}

/** order by stddev_pop() on columns of table "listing_with_token" */
export type Listing_With_Token_Stddev_Pop_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
}

/** order by stddev_samp() on columns of table "listing_with_token" */
export type Listing_With_Token_Stddev_Samp_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
}

/** order by sum() on columns of table "listing_with_token" */
export type Listing_With_Token_Sum_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
}

/** order by var_pop() on columns of table "listing_with_token" */
export type Listing_With_Token_Var_Pop_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
}

/** order by var_samp() on columns of table "listing_with_token" */
export type Listing_With_Token_Var_Samp_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
}

/** order by variance() on columns of table "listing_with_token" */
export type Listing_With_Token_Variance_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
}

export type Metadata_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Metadata_Aggregate_Bool_Exp_Bool_And>
  bool_or?: Maybe<Metadata_Aggregate_Bool_Exp_Bool_Or>
  count?: Maybe<Metadata_Aggregate_Bool_Exp_Count>
}

export type Metadata_Aggregate_Bool_Exp_Bool_And = {
  arguments: Metadata_Select_Column_Metadata_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: Maybe<Scalars['Boolean']>
  filter?: Maybe<MetadataBoolExp>
  predicate: BooleanComparisonExp
}

export type Metadata_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Metadata_Select_Column_Metadata_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: Maybe<Scalars['Boolean']>
  filter?: Maybe<MetadataBoolExp>
  predicate: BooleanComparisonExp
}

export type Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<MetadataSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
  filter?: Maybe<MetadataBoolExp>
  predicate: IntComparisonExp
}

/** order by avg() on columns of table "metadata" */
export type Metadata_Avg_Order_By = {
  editionNonce?: Maybe<OrderBy>
  sellerFeeBasisPoints?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  usesRemaining?: Maybe<OrderBy>
  usesTotal?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by max() on columns of table "metadata" */
export type Metadata_Max_Order_By = {
  collectionKey?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  editionNonce?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  key?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  name?: Maybe<OrderBy>
  sellerFeeBasisPoints?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  symbol?: Maybe<OrderBy>
  tokenStandard?: Maybe<OrderBy>
  updateAuthority?: Maybe<OrderBy>
  uri?: Maybe<OrderBy>
  usesRemaining?: Maybe<OrderBy>
  usesTotal?: Maybe<OrderBy>
  usesUseMethod?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by min() on columns of table "metadata" */
export type Metadata_Min_Order_By = {
  collectionKey?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  editionNonce?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  key?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  name?: Maybe<OrderBy>
  sellerFeeBasisPoints?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  symbol?: Maybe<OrderBy>
  tokenStandard?: Maybe<OrderBy>
  updateAuthority?: Maybe<OrderBy>
  uri?: Maybe<OrderBy>
  usesRemaining?: Maybe<OrderBy>
  usesTotal?: Maybe<OrderBy>
  usesUseMethod?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** select "metadata_aggregate_bool_exp_bool_and_arguments_columns" columns of table "metadata" */
export enum Metadata_Select_Column_Metadata_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CollectionVerified = 'collectionVerified',
  /** column name */
  IsMutable = 'isMutable',
  /** column name */
  PrimarySaleHappened = 'primarySaleHappened',
}

/** select "metadata_aggregate_bool_exp_bool_or_arguments_columns" columns of table "metadata" */
export enum Metadata_Select_Column_Metadata_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CollectionVerified = 'collectionVerified',
  /** column name */
  IsMutable = 'isMutable',
  /** column name */
  PrimarySaleHappened = 'primarySaleHappened',
}

/** order by stddev() on columns of table "metadata" */
export type Metadata_Stddev_Order_By = {
  editionNonce?: Maybe<OrderBy>
  sellerFeeBasisPoints?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  usesRemaining?: Maybe<OrderBy>
  usesTotal?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev_pop() on columns of table "metadata" */
export type Metadata_Stddev_Pop_Order_By = {
  editionNonce?: Maybe<OrderBy>
  sellerFeeBasisPoints?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  usesRemaining?: Maybe<OrderBy>
  usesTotal?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev_samp() on columns of table "metadata" */
export type Metadata_Stddev_Samp_Order_By = {
  editionNonce?: Maybe<OrderBy>
  sellerFeeBasisPoints?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  usesRemaining?: Maybe<OrderBy>
  usesTotal?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by sum() on columns of table "metadata" */
export type Metadata_Sum_Order_By = {
  editionNonce?: Maybe<OrderBy>
  sellerFeeBasisPoints?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  usesRemaining?: Maybe<OrderBy>
  usesTotal?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by var_pop() on columns of table "metadata" */
export type Metadata_Var_Pop_Order_By = {
  editionNonce?: Maybe<OrderBy>
  sellerFeeBasisPoints?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  usesRemaining?: Maybe<OrderBy>
  usesTotal?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by var_samp() on columns of table "metadata" */
export type Metadata_Var_Samp_Order_By = {
  editionNonce?: Maybe<OrderBy>
  sellerFeeBasisPoints?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  usesRemaining?: Maybe<OrderBy>
  usesTotal?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by variance() on columns of table "metadata" */
export type Metadata_Variance_Order_By = {
  editionNonce?: Maybe<OrderBy>
  sellerFeeBasisPoints?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  usesRemaining?: Maybe<OrderBy>
  usesTotal?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by avg() on columns of table "mint_relation" */
export type Mint_Relation_Avg_Order_By = {
  amountSum?: Maybe<OrderBy>
  ownerCount?: Maybe<OrderBy>
}

/** order by max() on columns of table "mint_relation" */
export type Mint_Relation_Max_Order_By = {
  amountSum?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  ownerCount?: Maybe<OrderBy>
  relatedMint?: Maybe<OrderBy>
}

/** order by min() on columns of table "mint_relation" */
export type Mint_Relation_Min_Order_By = {
  amountSum?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  ownerCount?: Maybe<OrderBy>
  relatedMint?: Maybe<OrderBy>
}

/** order by stddev() on columns of table "mint_relation" */
export type Mint_Relation_Stddev_Order_By = {
  amountSum?: Maybe<OrderBy>
  ownerCount?: Maybe<OrderBy>
}

/** order by stddev_pop() on columns of table "mint_relation" */
export type Mint_Relation_Stddev_Pop_Order_By = {
  amountSum?: Maybe<OrderBy>
  ownerCount?: Maybe<OrderBy>
}

/** order by stddev_samp() on columns of table "mint_relation" */
export type Mint_Relation_Stddev_Samp_Order_By = {
  amountSum?: Maybe<OrderBy>
  ownerCount?: Maybe<OrderBy>
}

/** order by sum() on columns of table "mint_relation" */
export type Mint_Relation_Sum_Order_By = {
  amountSum?: Maybe<OrderBy>
  ownerCount?: Maybe<OrderBy>
}

/** order by var_pop() on columns of table "mint_relation" */
export type Mint_Relation_Var_Pop_Order_By = {
  amountSum?: Maybe<OrderBy>
  ownerCount?: Maybe<OrderBy>
}

/** order by var_samp() on columns of table "mint_relation" */
export type Mint_Relation_Var_Samp_Order_By = {
  amountSum?: Maybe<OrderBy>
  ownerCount?: Maybe<OrderBy>
}

/** order by variance() on columns of table "mint_relation" */
export type Mint_Relation_Variance_Order_By = {
  amountSum?: Maybe<OrderBy>
  ownerCount?: Maybe<OrderBy>
}

export type Primary_Receipt_Aggregate_Bool_Exp = {
  count?: Maybe<Primary_Receipt_Aggregate_Bool_Exp_Count>
}

export type Primary_Receipt_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<PrimaryReceiptSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
  filter?: Maybe<PrimaryReceiptBoolExp>
  predicate: IntComparisonExp
}

/** order by avg() on columns of table "primary_receipt" */
export type Primary_Receipt_Avg_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by max() on columns of table "primary_receipt" */
export type Primary_Receipt_Max_Order_By = {
  buyer?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by min() on columns of table "primary_receipt" */
export type Primary_Receipt_Min_Order_By = {
  buyer?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev() on columns of table "primary_receipt" */
export type Primary_Receipt_Stddev_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev_pop() on columns of table "primary_receipt" */
export type Primary_Receipt_Stddev_Pop_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev_samp() on columns of table "primary_receipt" */
export type Primary_Receipt_Stddev_Samp_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by sum() on columns of table "primary_receipt" */
export type Primary_Receipt_Sum_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by var_pop() on columns of table "primary_receipt" */
export type Primary_Receipt_Var_Pop_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by var_samp() on columns of table "primary_receipt" */
export type Primary_Receipt_Var_Samp_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by variance() on columns of table "primary_receipt" */
export type Primary_Receipt_Variance_Order_By = {
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

export type Purchase_Receipt_Aggregate_Bool_Exp = {
  count?: Maybe<Purchase_Receipt_Aggregate_Bool_Exp_Count>
}

export type Purchase_Receipt_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<PurchaseReceiptSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
  filter?: Maybe<PurchaseReceiptBoolExp>
  predicate: IntComparisonExp
}

/** order by avg() on columns of table "purchase_receipt" */
export type Purchase_Receipt_Avg_Order_By = {
  bump?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by max() on columns of table "purchase_receipt" */
export type Purchase_Receipt_Max_Order_By = {
  auctionHouse?: Maybe<OrderBy>
  bookkeeper?: Maybe<OrderBy>
  bump?: Maybe<OrderBy>
  buyer?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  seller?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by min() on columns of table "purchase_receipt" */
export type Purchase_Receipt_Min_Order_By = {
  auctionHouse?: Maybe<OrderBy>
  bookkeeper?: Maybe<OrderBy>
  bump?: Maybe<OrderBy>
  buyer?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  metadata?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  seller?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev() on columns of table "purchase_receipt" */
export type Purchase_Receipt_Stddev_Order_By = {
  bump?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev_pop() on columns of table "purchase_receipt" */
export type Purchase_Receipt_Stddev_Pop_Order_By = {
  bump?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev_samp() on columns of table "purchase_receipt" */
export type Purchase_Receipt_Stddev_Samp_Order_By = {
  bump?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by sum() on columns of table "purchase_receipt" */
export type Purchase_Receipt_Sum_Order_By = {
  bump?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by var_pop() on columns of table "purchase_receipt" */
export type Purchase_Receipt_Var_Pop_Order_By = {
  bump?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by var_samp() on columns of table "purchase_receipt" */
export type Purchase_Receipt_Var_Samp_Order_By = {
  bump?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by variance() on columns of table "purchase_receipt" */
export type Purchase_Receipt_Variance_Order_By = {
  bump?: Maybe<OrderBy>
  createdAtOnChain?: Maybe<OrderBy>
  price?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  tokenSize?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

export type Query_Root = {
  __typename?: 'query_root'
  /** fetch data from the table: "auction_house" */
  auctionHouse: Array<AuctionHouse>
  /** fetch aggregated fields from the table: "auction_house" */
  auctionHouseAggregate: AuctionHouseAggregate
  /** fetch data from the table: "auction_house" using primary key columns */
  auctionHouseByPk?: Maybe<AuctionHouse>
  /** fetch data from the table: "bid_receipt" */
  bidReceipt: Array<BidReceipt>
  /** fetch aggregated fields from the table: "bid_receipt" */
  bidReceiptAggregate: BidReceiptAggregate
  /** fetch data from the table: "bid_receipt" using primary key columns */
  bidReceiptByPk?: Maybe<BidReceipt>
  /** fetch data from the table: "collector_leaderboard" */
  collectorLeaderboard: Array<CollectorLeaderboard>
  /** fetch data from the table: "creator" */
  creator: Array<Creator>
  /** fetch aggregated fields from the table: "creator" */
  creatorAggregate: CreatorAggregate
  /** fetch data from the table: "creator" using primary key columns */
  creatorByPk?: Maybe<Creator>
  /** fetch data from the table: "creator_leaderboard" */
  creatorLeaderboard: Array<CreatorLeaderboard>
  /** fetch data from the table: "distances" */
  distances: Array<Distances>
  /** fetch data from the table: "drop_times" */
  dropTimes: Array<DropTimes>
  /** fetch aggregated fields from the table: "drop_times" */
  dropTimesAggregate: DropTimesAggregate
  /** fetch data from the table: "drop_times" using primary key columns */
  dropTimesByPk?: Maybe<DropTimes>
  /** fetch data from the table: "edition_metadata" */
  editionMetadata: Array<EditionMetadata>
  /** fetch aggregated fields from the table: "edition_metadata" */
  editionMetadataAggregate: EditionMetadataAggregate
  /** fetch data from the table: "edition_metadata" using primary key columns */
  editionMetadataByPk?: Maybe<EditionMetadata>
  /** fetch data from the table: "floor_price" */
  floorPrice: Array<FloorPrice>
  /** fetch aggregated fields from the table: "floor_price" */
  floorPriceAggregate: FloorPriceAggregate
  /** fetch data from the table: "listing_receipt" */
  listingReceipt: Array<ListingReceipt>
  /** fetch aggregated fields from the table: "listing_receipt" */
  listingReceiptAggregate: ListingReceiptAggregate
  /** fetch data from the table: "listing_receipt" using primary key columns */
  listingReceiptByPk?: Maybe<ListingReceipt>
  /** fetch data from the table: "listing_with_token" */
  listingWithToken: Array<ListingWithToken>
  /** fetch aggregated fields from the table: "listing_with_token" */
  listingWithTokenAggregate: ListingWithTokenAggregate
  /** fetch data from the table: "listings" */
  listings: Array<Listings>
  /** fetch aggregated fields from the table: "listings" */
  listingsAggregate: ListingsAggregate
  /** fetch data from the table: "metadata" */
  metadata: Array<Metadata>
  /** fetch aggregated fields from the table: "metadata" */
  metadataAggregate: MetadataAggregate
  /** fetch data from the table: "metadata" using primary key columns */
  metadataByPk?: Maybe<Metadata>
  /** fetch data from the table: "milestones" */
  milestones: Array<Milestones>
  /** fetch aggregated fields from the table: "milestones" */
  milestonesAggregate: MilestonesAggregate
  /** fetch data from the table: "milestones" using primary key columns */
  milestonesByPk?: Maybe<Milestones>
  /** fetch data from the table: "mint" */
  mint: Array<Mint>
  /** fetch aggregated fields from the table: "mint" */
  mintAggregate: MintAggregate
  /** fetch data from the table: "mint" using primary key columns */
  mintByPk?: Maybe<Mint>
  /** fetch data from the table: "mint_relation" */
  mintRelation: Array<MintRelation>
  /** fetch data from the table: "primary_receipt" */
  primaryReceipt: Array<PrimaryReceipt>
  /** fetch aggregated fields from the table: "primary_receipt" */
  primaryReceiptAggregate: PrimaryReceiptAggregate
  /** fetch data from the table: "primary_receipt" using primary key columns */
  primaryReceiptByPk?: Maybe<PrimaryReceipt>
  /** fetch data from the table: "purchase_receipt" */
  purchaseReceipt: Array<PurchaseReceipt>
  /** fetch aggregated fields from the table: "purchase_receipt" */
  purchaseReceiptAggregate: PurchaseReceiptAggregate
  /** fetch data from the table: "purchase_receipt" using primary key columns */
  purchaseReceiptByPk?: Maybe<PurchaseReceipt>
  /** fetch data from the table: "receipt" */
  receipt: Array<Receipt>
  /** fetch data from the table: "token_account" */
  tokenAccount: Array<TokenAccount>
  /** fetch aggregated fields from the table: "token_account" */
  tokenAccountAggregate: TokenAccountAggregate
  /** fetch data from the table: "token_account" using primary key columns */
  tokenAccountByPk?: Maybe<TokenAccount>
  /** fetch data from the table: "video_leaderboard" */
  videoLeaderboard: Array<VideoLeaderboard>
}

export type Query_RootAuctionHouseArgs = {
  distinctOn?: Maybe<Array<AuctionHouseSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<AuctionHouseOrderBy>>
  where?: Maybe<AuctionHouseBoolExp>
}

export type Query_RootAuctionHouseAggregateArgs = {
  distinctOn?: Maybe<Array<AuctionHouseSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<AuctionHouseOrderBy>>
  where?: Maybe<AuctionHouseBoolExp>
}

export type Query_RootAuctionHouseByPkArgs = {
  id: Scalars['String']
}

export type Query_RootBidReceiptArgs = {
  distinctOn?: Maybe<Array<BidReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<BidReceiptOrderBy>>
  where?: Maybe<BidReceiptBoolExp>
}

export type Query_RootBidReceiptAggregateArgs = {
  distinctOn?: Maybe<Array<BidReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<BidReceiptOrderBy>>
  where?: Maybe<BidReceiptBoolExp>
}

export type Query_RootBidReceiptByPkArgs = {
  id: Scalars['String']
}

export type Query_RootCollectorLeaderboardArgs = {
  distinctOn?: Maybe<Array<CollectorLeaderboardSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<CollectorLeaderboardOrderBy>>
  where?: Maybe<CollectorLeaderboardBoolExp>
}

export type Query_RootCreatorArgs = {
  distinctOn?: Maybe<Array<CreatorSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<CreatorOrderBy>>
  where?: Maybe<CreatorBoolExp>
}

export type Query_RootCreatorAggregateArgs = {
  distinctOn?: Maybe<Array<CreatorSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<CreatorOrderBy>>
  where?: Maybe<CreatorBoolExp>
}

export type Query_RootCreatorByPkArgs = {
  address: Scalars['String']
  metadata: Scalars['String']
}

export type Query_RootCreatorLeaderboardArgs = {
  distinctOn?: Maybe<Array<CreatorLeaderboardSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<CreatorLeaderboardOrderBy>>
  where?: Maybe<CreatorLeaderboardBoolExp>
}

export type Query_RootDistancesArgs = {
  distinctOn?: Maybe<Array<DistancesSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<DistancesOrderBy>>
  where?: Maybe<DistancesBoolExp>
}

export type Query_RootDropTimesArgs = {
  distinctOn?: Maybe<Array<DropTimesSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<DropTimesOrderBy>>
  where?: Maybe<DropTimesBoolExp>
}

export type Query_RootDropTimesAggregateArgs = {
  distinctOn?: Maybe<Array<DropTimesSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<DropTimesOrderBy>>
  where?: Maybe<DropTimesBoolExp>
}

export type Query_RootDropTimesByPkArgs = {
  mint: Scalars['String']
}

export type Query_RootEditionMetadataArgs = {
  distinctOn?: Maybe<Array<EditionMetadataSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<EditionMetadataOrderBy>>
  where?: Maybe<EditionMetadataBoolExp>
}

export type Query_RootEditionMetadataAggregateArgs = {
  distinctOn?: Maybe<Array<EditionMetadataSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<EditionMetadataOrderBy>>
  where?: Maybe<EditionMetadataBoolExp>
}

export type Query_RootEditionMetadataByPkArgs = {
  id: Scalars['String']
}

export type Query_RootFloorPriceArgs = {
  distinctOn?: Maybe<Array<FloorPriceSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<FloorPriceOrderBy>>
  where?: Maybe<FloorPriceBoolExp>
}

export type Query_RootFloorPriceAggregateArgs = {
  distinctOn?: Maybe<Array<FloorPriceSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<FloorPriceOrderBy>>
  where?: Maybe<FloorPriceBoolExp>
}

export type Query_RootListingReceiptArgs = {
  distinctOn?: Maybe<Array<ListingReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingReceiptOrderBy>>
  where?: Maybe<ListingReceiptBoolExp>
}

export type Query_RootListingReceiptAggregateArgs = {
  distinctOn?: Maybe<Array<ListingReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingReceiptOrderBy>>
  where?: Maybe<ListingReceiptBoolExp>
}

export type Query_RootListingReceiptByPkArgs = {
  id: Scalars['String']
}

export type Query_RootListingWithTokenArgs = {
  distinctOn?: Maybe<Array<ListingWithTokenSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingWithTokenOrderBy>>
  where?: Maybe<ListingWithTokenBoolExp>
}

export type Query_RootListingWithTokenAggregateArgs = {
  distinctOn?: Maybe<Array<ListingWithTokenSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingWithTokenOrderBy>>
  where?: Maybe<ListingWithTokenBoolExp>
}

export type Query_RootListingsArgs = {
  distinctOn?: Maybe<Array<ListingsSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingsOrderBy>>
  where?: Maybe<ListingsBoolExp>
}

export type Query_RootListingsAggregateArgs = {
  distinctOn?: Maybe<Array<ListingsSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingsOrderBy>>
  where?: Maybe<ListingsBoolExp>
}

export type Query_RootMetadataArgs = {
  distinctOn?: Maybe<Array<MetadataSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MetadataOrderBy>>
  where?: Maybe<MetadataBoolExp>
}

export type Query_RootMetadataAggregateArgs = {
  distinctOn?: Maybe<Array<MetadataSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MetadataOrderBy>>
  where?: Maybe<MetadataBoolExp>
}

export type Query_RootMetadataByPkArgs = {
  id: Scalars['String']
}

export type Query_RootMilestonesArgs = {
  distinctOn?: Maybe<Array<MilestonesSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MilestonesOrderBy>>
  where?: Maybe<MilestonesBoolExp>
}

export type Query_RootMilestonesAggregateArgs = {
  distinctOn?: Maybe<Array<MilestonesSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MilestonesOrderBy>>
  where?: Maybe<MilestonesBoolExp>
}

export type Query_RootMilestonesByPkArgs = {
  mint: Scalars['String']
}

export type Query_RootMintArgs = {
  distinctOn?: Maybe<Array<MintSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MintOrderBy>>
  where?: Maybe<MintBoolExp>
}

export type Query_RootMintAggregateArgs = {
  distinctOn?: Maybe<Array<MintSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MintOrderBy>>
  where?: Maybe<MintBoolExp>
}

export type Query_RootMintByPkArgs = {
  id: Scalars['String']
}

export type Query_RootMintRelationArgs = {
  distinctOn?: Maybe<Array<MintRelationSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MintRelationOrderBy>>
  where?: Maybe<MintRelationBoolExp>
}

export type Query_RootPrimaryReceiptArgs = {
  distinctOn?: Maybe<Array<PrimaryReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<PrimaryReceiptOrderBy>>
  where?: Maybe<PrimaryReceiptBoolExp>
}

export type Query_RootPrimaryReceiptAggregateArgs = {
  distinctOn?: Maybe<Array<PrimaryReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<PrimaryReceiptOrderBy>>
  where?: Maybe<PrimaryReceiptBoolExp>
}

export type Query_RootPrimaryReceiptByPkArgs = {
  id: Scalars['String']
}

export type Query_RootPurchaseReceiptArgs = {
  distinctOn?: Maybe<Array<PurchaseReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<PurchaseReceiptOrderBy>>
  where?: Maybe<PurchaseReceiptBoolExp>
}

export type Query_RootPurchaseReceiptAggregateArgs = {
  distinctOn?: Maybe<Array<PurchaseReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<PurchaseReceiptOrderBy>>
  where?: Maybe<PurchaseReceiptBoolExp>
}

export type Query_RootPurchaseReceiptByPkArgs = {
  id: Scalars['String']
}

export type Query_RootReceiptArgs = {
  distinctOn?: Maybe<Array<ReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ReceiptOrderBy>>
  where?: Maybe<ReceiptBoolExp>
}

export type Query_RootTokenAccountArgs = {
  distinctOn?: Maybe<Array<TokenAccountSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<TokenAccountOrderBy>>
  where?: Maybe<TokenAccountBoolExp>
}

export type Query_RootTokenAccountAggregateArgs = {
  distinctOn?: Maybe<Array<TokenAccountSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<TokenAccountOrderBy>>
  where?: Maybe<TokenAccountBoolExp>
}

export type Query_RootTokenAccountByPkArgs = {
  id: Scalars['String']
}

export type Query_RootVideoLeaderboardArgs = {
  distinctOn?: Maybe<Array<VideoLeaderboardSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<VideoLeaderboardOrderBy>>
  where?: Maybe<VideoLeaderboardBoolExp>
}

export type Subscription_Root = {
  __typename?: 'subscription_root'
  /** fetch data from the table: "auction_house" */
  auctionHouse: Array<AuctionHouse>
  /** fetch aggregated fields from the table: "auction_house" */
  auctionHouseAggregate: AuctionHouseAggregate
  /** fetch data from the table: "auction_house" using primary key columns */
  auctionHouseByPk?: Maybe<AuctionHouse>
  /** fetch data from the table in a streaming manner: "auction_house" */
  auctionHouseStream: Array<AuctionHouse>
  /** fetch data from the table: "bid_receipt" */
  bidReceipt: Array<BidReceipt>
  /** fetch aggregated fields from the table: "bid_receipt" */
  bidReceiptAggregate: BidReceiptAggregate
  /** fetch data from the table: "bid_receipt" using primary key columns */
  bidReceiptByPk?: Maybe<BidReceipt>
  /** fetch data from the table in a streaming manner: "bid_receipt" */
  bidReceiptStream: Array<BidReceipt>
  /** fetch data from the table: "collector_leaderboard" */
  collectorLeaderboard: Array<CollectorLeaderboard>
  /** fetch data from the table in a streaming manner: "collector_leaderboard" */
  collectorLeaderboardStream: Array<CollectorLeaderboard>
  /** fetch data from the table: "creator" */
  creator: Array<Creator>
  /** fetch aggregated fields from the table: "creator" */
  creatorAggregate: CreatorAggregate
  /** fetch data from the table: "creator" using primary key columns */
  creatorByPk?: Maybe<Creator>
  /** fetch data from the table: "creator_leaderboard" */
  creatorLeaderboard: Array<CreatorLeaderboard>
  /** fetch data from the table in a streaming manner: "creator_leaderboard" */
  creatorLeaderboardStream: Array<CreatorLeaderboard>
  /** fetch data from the table in a streaming manner: "creator" */
  creatorStream: Array<Creator>
  /** fetch data from the table: "distances" */
  distances: Array<Distances>
  /** fetch data from the table in a streaming manner: "distances" */
  distancesStream: Array<Distances>
  /** fetch data from the table: "drop_times" */
  dropTimes: Array<DropTimes>
  /** fetch aggregated fields from the table: "drop_times" */
  dropTimesAggregate: DropTimesAggregate
  /** fetch data from the table: "drop_times" using primary key columns */
  dropTimesByPk?: Maybe<DropTimes>
  /** fetch data from the table in a streaming manner: "drop_times" */
  dropTimesStream: Array<DropTimes>
  /** fetch data from the table: "edition_metadata" */
  editionMetadata: Array<EditionMetadata>
  /** fetch aggregated fields from the table: "edition_metadata" */
  editionMetadataAggregate: EditionMetadataAggregate
  /** fetch data from the table: "edition_metadata" using primary key columns */
  editionMetadataByPk?: Maybe<EditionMetadata>
  /** fetch data from the table in a streaming manner: "edition_metadata" */
  editionMetadataStream: Array<EditionMetadata>
  /** fetch data from the table: "floor_price" */
  floorPrice: Array<FloorPrice>
  /** fetch aggregated fields from the table: "floor_price" */
  floorPriceAggregate: FloorPriceAggregate
  /** fetch data from the table in a streaming manner: "floor_price" */
  floorPriceStream: Array<FloorPrice>
  /** fetch data from the table: "listing_receipt" */
  listingReceipt: Array<ListingReceipt>
  /** fetch aggregated fields from the table: "listing_receipt" */
  listingReceiptAggregate: ListingReceiptAggregate
  /** fetch data from the table: "listing_receipt" using primary key columns */
  listingReceiptByPk?: Maybe<ListingReceipt>
  /** fetch data from the table in a streaming manner: "listing_receipt" */
  listingReceiptStream: Array<ListingReceipt>
  /** fetch data from the table: "listing_with_token" */
  listingWithToken: Array<ListingWithToken>
  /** fetch aggregated fields from the table: "listing_with_token" */
  listingWithTokenAggregate: ListingWithTokenAggregate
  /** fetch data from the table in a streaming manner: "listing_with_token" */
  listingWithTokenStream: Array<ListingWithToken>
  /** fetch data from the table: "listings" */
  listings: Array<Listings>
  /** fetch aggregated fields from the table: "listings" */
  listingsAggregate: ListingsAggregate
  /** fetch data from the table in a streaming manner: "listings" */
  listingsStream: Array<Listings>
  /** fetch data from the table: "metadata" */
  metadata: Array<Metadata>
  /** fetch aggregated fields from the table: "metadata" */
  metadataAggregate: MetadataAggregate
  /** fetch data from the table: "metadata" using primary key columns */
  metadataByPk?: Maybe<Metadata>
  /** fetch data from the table in a streaming manner: "metadata" */
  metadataStream: Array<Metadata>
  /** fetch data from the table: "milestones" */
  milestones: Array<Milestones>
  /** fetch aggregated fields from the table: "milestones" */
  milestonesAggregate: MilestonesAggregate
  /** fetch data from the table: "milestones" using primary key columns */
  milestonesByPk?: Maybe<Milestones>
  /** fetch data from the table in a streaming manner: "milestones" */
  milestonesStream: Array<Milestones>
  /** fetch data from the table: "mint" */
  mint: Array<Mint>
  /** fetch aggregated fields from the table: "mint" */
  mintAggregate: MintAggregate
  /** fetch data from the table: "mint" using primary key columns */
  mintByPk?: Maybe<Mint>
  /** fetch data from the table: "mint_relation" */
  mintRelation: Array<MintRelation>
  /** fetch data from the table in a streaming manner: "mint_relation" */
  mintRelationStream: Array<MintRelation>
  /** fetch data from the table in a streaming manner: "mint" */
  mintStream: Array<Mint>
  /** fetch data from the table: "primary_receipt" */
  primaryReceipt: Array<PrimaryReceipt>
  /** fetch aggregated fields from the table: "primary_receipt" */
  primaryReceiptAggregate: PrimaryReceiptAggregate
  /** fetch data from the table: "primary_receipt" using primary key columns */
  primaryReceiptByPk?: Maybe<PrimaryReceipt>
  /** fetch data from the table in a streaming manner: "primary_receipt" */
  primaryReceiptStream: Array<PrimaryReceipt>
  /** fetch data from the table: "purchase_receipt" */
  purchaseReceipt: Array<PurchaseReceipt>
  /** fetch aggregated fields from the table: "purchase_receipt" */
  purchaseReceiptAggregate: PurchaseReceiptAggregate
  /** fetch data from the table: "purchase_receipt" using primary key columns */
  purchaseReceiptByPk?: Maybe<PurchaseReceipt>
  /** fetch data from the table in a streaming manner: "purchase_receipt" */
  purchaseReceiptStream: Array<PurchaseReceipt>
  /** fetch data from the table: "receipt" */
  receipt: Array<Receipt>
  /** fetch data from the table in a streaming manner: "receipt" */
  receiptStream: Array<Receipt>
  /** fetch data from the table: "token_account" */
  tokenAccount: Array<TokenAccount>
  /** fetch aggregated fields from the table: "token_account" */
  tokenAccountAggregate: TokenAccountAggregate
  /** fetch data from the table: "token_account" using primary key columns */
  tokenAccountByPk?: Maybe<TokenAccount>
  /** fetch data from the table in a streaming manner: "token_account" */
  tokenAccountStream: Array<TokenAccount>
  /** fetch data from the table: "video_leaderboard" */
  videoLeaderboard: Array<VideoLeaderboard>
  /** fetch data from the table in a streaming manner: "video_leaderboard" */
  videoLeaderboardStream: Array<VideoLeaderboard>
}

export type Subscription_RootAuctionHouseArgs = {
  distinctOn?: Maybe<Array<AuctionHouseSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<AuctionHouseOrderBy>>
  where?: Maybe<AuctionHouseBoolExp>
}

export type Subscription_RootAuctionHouseAggregateArgs = {
  distinctOn?: Maybe<Array<AuctionHouseSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<AuctionHouseOrderBy>>
  where?: Maybe<AuctionHouseBoolExp>
}

export type Subscription_RootAuctionHouseByPkArgs = {
  id: Scalars['String']
}

export type Subscription_RootAuctionHouseStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<AuctionHouseStreamCursorInput>>
  where?: Maybe<AuctionHouseBoolExp>
}

export type Subscription_RootBidReceiptArgs = {
  distinctOn?: Maybe<Array<BidReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<BidReceiptOrderBy>>
  where?: Maybe<BidReceiptBoolExp>
}

export type Subscription_RootBidReceiptAggregateArgs = {
  distinctOn?: Maybe<Array<BidReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<BidReceiptOrderBy>>
  where?: Maybe<BidReceiptBoolExp>
}

export type Subscription_RootBidReceiptByPkArgs = {
  id: Scalars['String']
}

export type Subscription_RootBidReceiptStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<BidReceiptStreamCursorInput>>
  where?: Maybe<BidReceiptBoolExp>
}

export type Subscription_RootCollectorLeaderboardArgs = {
  distinctOn?: Maybe<Array<CollectorLeaderboardSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<CollectorLeaderboardOrderBy>>
  where?: Maybe<CollectorLeaderboardBoolExp>
}

export type Subscription_RootCollectorLeaderboardStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<CollectorLeaderboardStreamCursorInput>>
  where?: Maybe<CollectorLeaderboardBoolExp>
}

export type Subscription_RootCreatorArgs = {
  distinctOn?: Maybe<Array<CreatorSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<CreatorOrderBy>>
  where?: Maybe<CreatorBoolExp>
}

export type Subscription_RootCreatorAggregateArgs = {
  distinctOn?: Maybe<Array<CreatorSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<CreatorOrderBy>>
  where?: Maybe<CreatorBoolExp>
}

export type Subscription_RootCreatorByPkArgs = {
  address: Scalars['String']
  metadata: Scalars['String']
}

export type Subscription_RootCreatorLeaderboardArgs = {
  distinctOn?: Maybe<Array<CreatorLeaderboardSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<CreatorLeaderboardOrderBy>>
  where?: Maybe<CreatorLeaderboardBoolExp>
}

export type Subscription_RootCreatorLeaderboardStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<CreatorLeaderboardStreamCursorInput>>
  where?: Maybe<CreatorLeaderboardBoolExp>
}

export type Subscription_RootCreatorStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<CreatorStreamCursorInput>>
  where?: Maybe<CreatorBoolExp>
}

export type Subscription_RootDistancesArgs = {
  distinctOn?: Maybe<Array<DistancesSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<DistancesOrderBy>>
  where?: Maybe<DistancesBoolExp>
}

export type Subscription_RootDistancesStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<DistancesStreamCursorInput>>
  where?: Maybe<DistancesBoolExp>
}

export type Subscription_RootDropTimesArgs = {
  distinctOn?: Maybe<Array<DropTimesSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<DropTimesOrderBy>>
  where?: Maybe<DropTimesBoolExp>
}

export type Subscription_RootDropTimesAggregateArgs = {
  distinctOn?: Maybe<Array<DropTimesSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<DropTimesOrderBy>>
  where?: Maybe<DropTimesBoolExp>
}

export type Subscription_RootDropTimesByPkArgs = {
  mint: Scalars['String']
}

export type Subscription_RootDropTimesStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<DropTimesStreamCursorInput>>
  where?: Maybe<DropTimesBoolExp>
}

export type Subscription_RootEditionMetadataArgs = {
  distinctOn?: Maybe<Array<EditionMetadataSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<EditionMetadataOrderBy>>
  where?: Maybe<EditionMetadataBoolExp>
}

export type Subscription_RootEditionMetadataAggregateArgs = {
  distinctOn?: Maybe<Array<EditionMetadataSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<EditionMetadataOrderBy>>
  where?: Maybe<EditionMetadataBoolExp>
}

export type Subscription_RootEditionMetadataByPkArgs = {
  id: Scalars['String']
}

export type Subscription_RootEditionMetadataStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<EditionMetadataStreamCursorInput>>
  where?: Maybe<EditionMetadataBoolExp>
}

export type Subscription_RootFloorPriceArgs = {
  distinctOn?: Maybe<Array<FloorPriceSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<FloorPriceOrderBy>>
  where?: Maybe<FloorPriceBoolExp>
}

export type Subscription_RootFloorPriceAggregateArgs = {
  distinctOn?: Maybe<Array<FloorPriceSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<FloorPriceOrderBy>>
  where?: Maybe<FloorPriceBoolExp>
}

export type Subscription_RootFloorPriceStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<FloorPriceStreamCursorInput>>
  where?: Maybe<FloorPriceBoolExp>
}

export type Subscription_RootListingReceiptArgs = {
  distinctOn?: Maybe<Array<ListingReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingReceiptOrderBy>>
  where?: Maybe<ListingReceiptBoolExp>
}

export type Subscription_RootListingReceiptAggregateArgs = {
  distinctOn?: Maybe<Array<ListingReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingReceiptOrderBy>>
  where?: Maybe<ListingReceiptBoolExp>
}

export type Subscription_RootListingReceiptByPkArgs = {
  id: Scalars['String']
}

export type Subscription_RootListingReceiptStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<ListingReceiptStreamCursorInput>>
  where?: Maybe<ListingReceiptBoolExp>
}

export type Subscription_RootListingWithTokenArgs = {
  distinctOn?: Maybe<Array<ListingWithTokenSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingWithTokenOrderBy>>
  where?: Maybe<ListingWithTokenBoolExp>
}

export type Subscription_RootListingWithTokenAggregateArgs = {
  distinctOn?: Maybe<Array<ListingWithTokenSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingWithTokenOrderBy>>
  where?: Maybe<ListingWithTokenBoolExp>
}

export type Subscription_RootListingWithTokenStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<ListingWithTokenStreamCursorInput>>
  where?: Maybe<ListingWithTokenBoolExp>
}

export type Subscription_RootListingsArgs = {
  distinctOn?: Maybe<Array<ListingsSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingsOrderBy>>
  where?: Maybe<ListingsBoolExp>
}

export type Subscription_RootListingsAggregateArgs = {
  distinctOn?: Maybe<Array<ListingsSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ListingsOrderBy>>
  where?: Maybe<ListingsBoolExp>
}

export type Subscription_RootListingsStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<ListingsStreamCursorInput>>
  where?: Maybe<ListingsBoolExp>
}

export type Subscription_RootMetadataArgs = {
  distinctOn?: Maybe<Array<MetadataSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MetadataOrderBy>>
  where?: Maybe<MetadataBoolExp>
}

export type Subscription_RootMetadataAggregateArgs = {
  distinctOn?: Maybe<Array<MetadataSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MetadataOrderBy>>
  where?: Maybe<MetadataBoolExp>
}

export type Subscription_RootMetadataByPkArgs = {
  id: Scalars['String']
}

export type Subscription_RootMetadataStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<MetadataStreamCursorInput>>
  where?: Maybe<MetadataBoolExp>
}

export type Subscription_RootMilestonesArgs = {
  distinctOn?: Maybe<Array<MilestonesSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MilestonesOrderBy>>
  where?: Maybe<MilestonesBoolExp>
}

export type Subscription_RootMilestonesAggregateArgs = {
  distinctOn?: Maybe<Array<MilestonesSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MilestonesOrderBy>>
  where?: Maybe<MilestonesBoolExp>
}

export type Subscription_RootMilestonesByPkArgs = {
  mint: Scalars['String']
}

export type Subscription_RootMilestonesStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<MilestonesStreamCursorInput>>
  where?: Maybe<MilestonesBoolExp>
}

export type Subscription_RootMintArgs = {
  distinctOn?: Maybe<Array<MintSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MintOrderBy>>
  where?: Maybe<MintBoolExp>
}

export type Subscription_RootMintAggregateArgs = {
  distinctOn?: Maybe<Array<MintSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MintOrderBy>>
  where?: Maybe<MintBoolExp>
}

export type Subscription_RootMintByPkArgs = {
  id: Scalars['String']
}

export type Subscription_RootMintRelationArgs = {
  distinctOn?: Maybe<Array<MintRelationSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<MintRelationOrderBy>>
  where?: Maybe<MintRelationBoolExp>
}

export type Subscription_RootMintRelationStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<MintRelationStreamCursorInput>>
  where?: Maybe<MintRelationBoolExp>
}

export type Subscription_RootMintStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<MintStreamCursorInput>>
  where?: Maybe<MintBoolExp>
}

export type Subscription_RootPrimaryReceiptArgs = {
  distinctOn?: Maybe<Array<PrimaryReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<PrimaryReceiptOrderBy>>
  where?: Maybe<PrimaryReceiptBoolExp>
}

export type Subscription_RootPrimaryReceiptAggregateArgs = {
  distinctOn?: Maybe<Array<PrimaryReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<PrimaryReceiptOrderBy>>
  where?: Maybe<PrimaryReceiptBoolExp>
}

export type Subscription_RootPrimaryReceiptByPkArgs = {
  id: Scalars['String']
}

export type Subscription_RootPrimaryReceiptStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<PrimaryReceiptStreamCursorInput>>
  where?: Maybe<PrimaryReceiptBoolExp>
}

export type Subscription_RootPurchaseReceiptArgs = {
  distinctOn?: Maybe<Array<PurchaseReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<PurchaseReceiptOrderBy>>
  where?: Maybe<PurchaseReceiptBoolExp>
}

export type Subscription_RootPurchaseReceiptAggregateArgs = {
  distinctOn?: Maybe<Array<PurchaseReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<PurchaseReceiptOrderBy>>
  where?: Maybe<PurchaseReceiptBoolExp>
}

export type Subscription_RootPurchaseReceiptByPkArgs = {
  id: Scalars['String']
}

export type Subscription_RootPurchaseReceiptStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<PurchaseReceiptStreamCursorInput>>
  where?: Maybe<PurchaseReceiptBoolExp>
}

export type Subscription_RootReceiptArgs = {
  distinctOn?: Maybe<Array<ReceiptSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<ReceiptOrderBy>>
  where?: Maybe<ReceiptBoolExp>
}

export type Subscription_RootReceiptStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<ReceiptStreamCursorInput>>
  where?: Maybe<ReceiptBoolExp>
}

export type Subscription_RootTokenAccountArgs = {
  distinctOn?: Maybe<Array<TokenAccountSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<TokenAccountOrderBy>>
  where?: Maybe<TokenAccountBoolExp>
}

export type Subscription_RootTokenAccountAggregateArgs = {
  distinctOn?: Maybe<Array<TokenAccountSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<TokenAccountOrderBy>>
  where?: Maybe<TokenAccountBoolExp>
}

export type Subscription_RootTokenAccountByPkArgs = {
  id: Scalars['String']
}

export type Subscription_RootTokenAccountStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<TokenAccountStreamCursorInput>>
  where?: Maybe<TokenAccountBoolExp>
}

export type Subscription_RootVideoLeaderboardArgs = {
  distinctOn?: Maybe<Array<VideoLeaderboardSelectColumn>>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
  orderBy?: Maybe<Array<VideoLeaderboardOrderBy>>
  where?: Maybe<VideoLeaderboardBoolExp>
}

export type Subscription_RootVideoLeaderboardStreamArgs = {
  batchSize: Scalars['Int']
  cursor: Array<Maybe<VideoLeaderboardStreamCursorInput>>
  where?: Maybe<VideoLeaderboardBoolExp>
}

export type Token_Account_Aggregate_Bool_Exp = {
  count?: Maybe<Token_Account_Aggregate_Bool_Exp_Count>
}

export type Token_Account_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<TokenAccountSelectColumn>>
  distinct?: Maybe<Scalars['Boolean']>
  filter?: Maybe<TokenAccountBoolExp>
  predicate: IntComparisonExp
}

/** order by avg() on columns of table "token_account" */
export type Token_Account_Avg_Order_By = {
  amount?: Maybe<OrderBy>
  delegatedAmount?: Maybe<OrderBy>
  isNative?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by max() on columns of table "token_account" */
export type Token_Account_Max_Order_By = {
  amount?: Maybe<OrderBy>
  closeAuthority?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  delegate?: Maybe<OrderBy>
  delegatedAmount?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  isNative?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  owner?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  state?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by min() on columns of table "token_account" */
export type Token_Account_Min_Order_By = {
  amount?: Maybe<OrderBy>
  closeAuthority?: Maybe<OrderBy>
  createdAt?: Maybe<OrderBy>
  delegate?: Maybe<OrderBy>
  delegatedAmount?: Maybe<OrderBy>
  id?: Maybe<OrderBy>
  isNative?: Maybe<OrderBy>
  mint?: Maybe<OrderBy>
  modifiedAt?: Maybe<OrderBy>
  owner?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  state?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev() on columns of table "token_account" */
export type Token_Account_Stddev_Order_By = {
  amount?: Maybe<OrderBy>
  delegatedAmount?: Maybe<OrderBy>
  isNative?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev_pop() on columns of table "token_account" */
export type Token_Account_Stddev_Pop_Order_By = {
  amount?: Maybe<OrderBy>
  delegatedAmount?: Maybe<OrderBy>
  isNative?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by stddev_samp() on columns of table "token_account" */
export type Token_Account_Stddev_Samp_Order_By = {
  amount?: Maybe<OrderBy>
  delegatedAmount?: Maybe<OrderBy>
  isNative?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by sum() on columns of table "token_account" */
export type Token_Account_Sum_Order_By = {
  amount?: Maybe<OrderBy>
  delegatedAmount?: Maybe<OrderBy>
  isNative?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by var_pop() on columns of table "token_account" */
export type Token_Account_Var_Pop_Order_By = {
  amount?: Maybe<OrderBy>
  delegatedAmount?: Maybe<OrderBy>
  isNative?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by var_samp() on columns of table "token_account" */
export type Token_Account_Var_Samp_Order_By = {
  amount?: Maybe<OrderBy>
  delegatedAmount?: Maybe<OrderBy>
  isNative?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}

/** order by variance() on columns of table "token_account" */
export type Token_Account_Variance_Order_By = {
  amount?: Maybe<OrderBy>
  delegatedAmount?: Maybe<OrderBy>
  isNative?: Maybe<OrderBy>
  slot?: Maybe<OrderBy>
  writeVersion?: Maybe<OrderBy>
}
